import { useState, useEffect, useMemo } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
// import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import { formatDate } from "../../../utils/dateUtils.js"
import Select from "react-select"
import {
  createReceptionistAction,
  getReceptionistsAction,
  addVitalsAction,
  collectPaymentAction,
  markPatientCurrentAction,
  upcomingAppointmentAction,
  removePatientAction,
  sendFormLinkAction,
  pauseDoctorQueueAction,
  markPatientEmergencyAction,
  markPatientCompleteAction,
  getBookedAppointmentsAction,
  markPatientNextAction,
  sendReminderAction,
  uploadPatientPhotoAction,
  addBackToQueueAction,
  addSearchPatientQueueAction
} from "../../../store/actions/ReceptionistAction"
import defaultAvatar from "../../../../src/assets/images/placeholder.jpg"
import { fetchReceptionistDashboardAction } from "../../../store/actions/DashboardCardAction"
import CommonPaymentModal from "../Common/CommonPaymentModal"
import { getDoctorsAction } from "../../../store/actions/DoctorsAction"
import { cancelLeadAppointment } from "../../../services/AppointmentService"
import { handleSuccess, showErrorAlert } from "../../../services/ErrorHandlingService"
import { Html5Qrcode } from "html5-qrcode"
import Swal from "sweetalert2"
import { Link, useLocation } from "react-router-dom"
import { Modal, Button } from "react-bootstrap"
import avatar1 from "../../../../src/assets/images/avatar/1.png"
import avatar3 from "../../../../src/assets/images/avatar/3.png"
import avatar4 from "../../../../src/assets/images/avatar/4.png"
import scannerIcon from "../../../../src/assets/images/qr-code.png"
import icon from "../../../../src/assets/images/VitalsSheet.png"
import backtoqueue from "../../../../src/assets/images/add_back_queue.png"
import Sharelink from "../../../../src/assets/images/share-link.png"
import Loader from "../Common/Loader.jsx"
import { shouldDisableActionsForPartner } from "../../../services/ReceptionistService";
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import pdfIcon from "../../../../src/assets/images/icons8-pdf-50.png"
import { formatName } from "../../../utils/formatName.js"
import Appointmentlist from "./Appoinmentlist";
import Reshedule from "../../../../src/assets/images/deadline.png";
import Markcurrent from "../../../../src/assets/images/check_11601272.png"
import Markasnext from "../../../../src/assets/images/next_189241.png"
import call from "../../../../src/assets/images/icons8-call-102.png"
import emergencyIcon from "../../../../src/assets/images/emergancy.png"
import cancel from "../../../../src/assets/images/cancel_app.png"
import remainder from "../../../../src/assets/images/calendar1.png"
import collectpayment from "../../../../src/assets/images/collect_payment.png"
import { markPatientAsCurrent } from "../../../services/ReceptionistService.js"
import { getPatientsAction } from "../../../store/actions/PatientsAction";
import { getAvailableSlotsAction } from "../../../store/actions/AssignedAppointmentAction";
import connect from "../../../../src/assets/images/social-media_12891222.png"
import axiosInstance from "../../../services/AxiosInstance"


const Receptionist = () => {
  const [showScanner, setShowScanner] = useState(false)
  const [showVitalsModal, setShowVitalsModal] = useState(false)
  const [showRescheduleModal, setShowRescheduleModal] = useState(false)
  const [selectedAppointmentForReschedule, setSelectedAppointmentForReschedule] = useState(null)
  const doctors = useSelector((state) => state.doctors.doctors || [])
  const [uploadedFiles, setUploadedFiles] = useState([]) // This state is for the table display
  const [selectedDate, setSelectedDate] = useState("")
  const [vitalsPatient, setVitalsPatient] = useState(null)
  const [loading, setLoading] = useState(false)
  const [selectedDoctorId, setSelectedDoctorId] = useState(null);

  const location = useLocation()
  const sentLinks = useSelector((state) => state.receptionists?.sentLinks || [])
  const dispatch = useDispatch()
  const [rightPanelLoading, setRightPanelLoading] = useState(false)
  const navigate = useNavigate()
  const emergencyPatients = useSelector((state) => state.receptionists?.emergencyPatients || [])
  const [sendingLinkPatientId, setSendingLinkPatientId] = useState()
  const [doctorError, setDoctorError] = useState("")
  const isPaused = useSelector((state) => state.receptionists?.isPaused)
  const doctorId = JSON.parse(localStorage.getItem("doctorId")) || 0
  const [enqueuedPatientIds, setEnqueuedPatientIds] = useState([])
  const [submittingVitals, setSubmittingVitals] = useState(false)
  const [selectedDoctorOption, setSelectedDoctorOption] = useState(null);
  // Consolidated loading states for all actions
  const [actionLoading, setActionLoading] = useState({
    markingCurrent: null,
    markingNext: null,
    removing: null,
    emergencyMarking: null,
    completing: null,
    enqueuing: null,
    canceling: null,
    sendingReminder: null,
    downloading: null,
    uploadingPhoto: null,
    backToQueue: null,
    pausing: false,
    scanning: false,
    rescheduling: null,
    confirmingSlot: false,
    reschedulingSlot: false,
    vitalsOpening: null,
    collectingPayment: false
  })

  const [searchQuery, setSearchQuery] = useState("");
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const [patientPhoto, setPatientPhoto] = useState(null);
  const [photoPreview, setPhotoPreview] = useState(null);
  // Instead of a single preview, store it per patient
  const [photoPreviews, setPhotoPreviews] = useState({});
  // define for appoinment
  const [showSlotModal, setShowSlotModal] = useState(false);
  const [modalDoctorId, setModalDoctorId] = useState("");
  const today = new Date().toISOString().split("T")[0];

  const [modalDate, setModalDate] = useState(today);
  const [timeSlots, setTimeSlots] = useState([]);
  const [modalTimeSlot, setModalTimeSlot] = useState(null);
  const [slotsData, setSlotsData] = useState([]);
  const [modalDoctorOptions, setModalDoctorOptions] = useState([]);

  // Reschedule Modal State
  const [rescheduleModalDoctorId, setRescheduleModalDoctorId] = useState("");
  const [rescheduleModalDate, setRescheduleModalDate] = useState(today);
  const [rescheduleModalTimeSlot, setRescheduleModalTimeSlot] = useState(null);
  const [rescheduleSlotsData, setRescheduleSlotsData] = useState([]);
  const [rescheduleModalDoctorOptions, setRescheduleModalDoctorOptions] = useState([]);
  const [openShareMenuId, setOpenShareMenuId] = useState(null);
   
  // Appointment Details State
  const [appointmentDetails, setAppointmentDetails] = useState(null);
  const [fetchingAppointmentDetails, setFetchingAppointmentDetails] = useState(false);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [modalMode, setModalMode] = useState(null); // "appointment" for QR scan flow, "reschedule" for queue reschedule flow

  const [photoModalPatient, setPhotoModalPatient] = useState(null);
  const [showPhotoOptions, setShowPhotoOptions] = useState(false);

  // Get admin_id properly
  const admin_id = JSON.parse(localStorage.getItem("loginDetails"))?.id || 1
  const dashboardData = useSelector((state) => {
    console.log("Dashboard Data:", state.dashboard.receptionistsDashboard)
    return state.dashboard.receptionistsDashboard || {}
  })
  const [downloadingId, setDownloadingId] = useState(null)
  const searchedPatients = useSelector(
    (state) => state.patients?.patients || []
  );

  // Helper function to get loading ID (queue_id preferred, fallback to patient_id)
  const getLoadingId = (patient) => {
    return patient.queue_id || patient.patient_id;
  };

  // Get single highest priority status for patient
  const getPatientStatus = (patient) => {
    // ✅ Priority 0: PARTNER FORM PENDING (HIGHEST)
    if (isPartnerFormPending(patient)) {
      return {
        label: "Partner Form Pending",
        message: "",
        color: "#ff6b6b",
        icon: "fas fa-exclamation-circle",
        priority: 0
      };
    }

    // Priority 1: Emergency (highest after partner)
    if (isEmergencyPatient(patient)) {
      return {
        label: "Emergency",
        message: "",
        color: "#dc3545",
        icon: "fas fa-exclamation-triangle",
        priority: 1
      };
    }

    // Priority 2: Not Scanned
    if (patient.is_presented === "No") {
      return {
        label: "Not Scanned",
        message: "",
        color: "#495057",
        icon: "fas fa-qrcode",
        priority: 2
      };
    }

    // Priority 3: Form Pending
    if (patient.queueDetails?.questionnaire_filled === "No" || patient.questionnaire_filled === "No") {
      return {
        label: "Form Pending",
        message: "",
        color: "#ff9f40",
        icon: "fas fa-clipboard",
        priority: 3
      };
    }

    // Priority 4: Vitals Pending
    const isVitalsMissing =
      (!patient.systolic_bp || patient.systolic_bp === "0") &&
      (!patient.diastolic_bp || patient.diastolic_bp === "0") &&
      (!patient.weight || patient.weight === "0") &&
      (!patient.height || patient.height === "0") &&
      (!patient.bmi || patient.bmi === "0") &&
      (!patient.pluse_rate || patient.pluse_rate === "0") &&
      (!patient.temperature || patient.temperature === "0") &&
      (!patient.Oxygen_Saturation || patient.Oxygen_Saturation === "0") &&
      (!patient.blood_glucose_level || patient.blood_glucose_level === "0");

    if (isVitalsMissing) {
      return {
        label: "Vitals Pending",
        message: "",
        color: "#6c757d",
        icon: "fas fa-heartbeat",
        priority: 4
      };
    }

    // Priority 5: Payment Pending (after vitals)
    const isPaymentPending = patient.is_payment === "No";
    if (isPaymentPending) {
      return {
        label: "Payment Pending",
        message: "",
        color: "#fd7e14",
        icon: "fas fa-credit-card",
        priority: 5
      };
    }

    // No status - patient is complete
    return null;
  };

  useEffect(() => {
    if (!searchQuery.trim()) {
      setShowSuggestions(false);
      return;
    }

    const keyword = searchQuery.trim();

    if (/^\d+$/.test(keyword)) {
      dispatch(getPatientsAction(false, 0, "whatsapp_contact_no", keyword));
    }
    else if (keyword.includes("@")) {
      dispatch(getPatientsAction(false, 0, "patient_email", keyword));
    }
    else {
      dispatch(getPatientsAction(false, 0, "first_name", keyword));
    }

    setShowSuggestions(true);

  }, [searchQuery, dispatch]);

  useEffect(() => {
    if (!selectedDate) return;

    dispatch(
      getBookedAppointmentsAction(
        selectedDate,
        selectedDoctorId || null
      )
    );
  }, [selectedDate, selectedDoctorId, dispatch]);
  const { availableSlots = [] } = useSelector(
    (state) => state.assignedAppointments || {}
  );
  useEffect(() => {
    if (!modalDoctorId || !modalDate) return;

    // ✅ Always fetch slots when doctor or date changes in modal
    // This ensures timeslots are loaded whenever user selects a doctor
    if (modalDoctorId == "0" || !modalDoctorId) {
      return;
    }

    dispatch(
      getAvailableSlotsAction({
        doctor_id: modalDoctorId,
        date: modalDate,
      })
    );
  }, [modalDoctorId, modalDate, dispatch]);
  
  useEffect(() => {
    if (!availableSlots || availableSlots.length === 0) {
      setSlotsData([]);
      return;
    }

    const formattedSlots = availableSlots.map((slot) => ({
      value: slot.time_slot,
      label: slot.time_slot,
      branch_id: slot.branch_id,           
      branch_name: slot.branch_name,       
      branch_location: slot.branch_location,
      opening_hour_id: slot.opening_hour_id,
      confirmed: Number(slot.confirmed_appointments || 0),
      max: Number(slot.max_appointments || 0),
      available: slot.available,
      is_full: slot.is_full,
    }));

    setSlotsData(formattedSlots);

    // ✅ FIX: Preserve existing time slot if it exists (even if not available - for confirmed appointments)
    const existingTimeSlotValue = modalTimeSlot?.value;
    if (existingTimeSlotValue) {
      const matchingSlot = formattedSlots.find(slot => slot.value === existingTimeSlotValue);
      if (matchingSlot) {
        // Keep the slot selected even if it's not "available" - this handles confirmed appointments
        setModalTimeSlot(matchingSlot);
        return;
      }
    }
    
    // Otherwise select first available slot for new appointments
    // const firstAvailableSlot = formattedSlots.find((slot) => slot.available);
    // setModalTimeSlot(firstAvailableSlot || null);
// ✅ ONLY auto-select slot
// when doctor manually selected

if (
  modalDoctorId &&
  modalDoctorId !== "0"
) {

  const firstAvailableSlot =
    formattedSlots.find(
      (slot) => slot.available
    );

  // ✅ ONLY for NEW appointment
  if (
    !appointmentDetails?.time_slot &&
    appointmentDetails?.is_confirmed == "No"
  ) {

    setModalTimeSlot(
      firstAvailableSlot || null
    );

  }

} else {

  // ❌ prevent auto slot
  setModalTimeSlot(null);

}
  }, [availableSlots]);

  // Reschedule Modal - Fetch slots when doctor or date changes
  useEffect(() => {
    if (!rescheduleModalDoctorId || !rescheduleModalDate) {
      setRescheduleSlotsData([]);
      setRescheduleModalTimeSlot(null);
      return;
    }

    dispatch(
      getAvailableSlotsAction({
        doctor_id: rescheduleModalDoctorId,
        date: rescheduleModalDate,
      })
    );
  }, [rescheduleModalDoctorId, rescheduleModalDate, dispatch]);

  // Handle reschedule slots data
  useEffect(() => {
    if (!availableSlots || availableSlots.length === 0) {
      setRescheduleSlotsData([]);
      setRescheduleModalTimeSlot(null);
      return;
    }

    const formattedSlots = availableSlots.map((slot) => ({
      value: slot.time_slot,
      label: slot.time_slot,
      opening_hour_id: slot.opening_hour_id,
      confirmed: Number(slot.confirmed_appointments || 0),
      max: Number(slot.max_appointments || 0),
      available: slot.available,
      is_full: slot.is_full,
    }));

    setRescheduleSlotsData(formattedSlots);

    // ✅ Select first available slot
    const firstAvailableSlot = formattedSlots.find((slot) => slot.available);
    setRescheduleModalTimeSlot(firstAvailableSlot || null);

  }, [availableSlots, rescheduleModalDoctorId, rescheduleModalDate]);

  useEffect(() => {
    // whenever you return to this page, clear stale vitals
    setVitalsPatient(null)
    setShowVitalsModal(false)
    setUploadedFiles([])
  }, [location.pathname])
  // Helper function to check if patient is emergency
  const isEmergencyPatient = (patient) => {
    return patient.is_emergency === "Yes" || patient.is_emergency === 1 || emergencyPatients.includes(patient.queue_id)
  }

  // Helper function to check if questionnaire is filled
  const isQuestionnaireFilled = (patient) => {
    // Check both queueDetails and direct property
    const queueQuestionnaire = patient.queueDetails?.questionnaire_filled;
    const directQuestionnaire = patient.questionnaire_filled;
    
    const filled = queueQuestionnaire || directQuestionnaire;
    return filled === "Yes" || filled?.trim().toLowerCase() === "yes";
  }

  // ✅ CHECK IF PARTNER FORM IS PENDING
  const isPartnerFormPending = (patient) => {
    return patient.partnerDetails && 
           patient.partnerDetails.questionnaire_filled === "No"
  }

  // ✅ GET PARTNER FORM STATUS WITH PRIORITY
  const getPartnerFormStatus = (patient) => {
    if (!isPartnerFormPending(patient)) return null

    return {
      label: "Partner Form Pending",
      color: "#ff6b6b",
      icon: "fas fa-exclamation-circle",
      actionRequired: true
    }
  }

  // Helper function to check if patient can perform actions (has queue_id or is_presented is "Yes")

  const canPerformActions = (patient) => {

    // ❌ BLOCK ALL ACTIONS IF PARTNER FORM PENDING
 
    if (shouldDisableActionsForPartner(patient)) {
      return false;
    }
    // ✅ Allow if patient in queue
    if (patient.queue_id) return true;
  
    // ✅ Allow if presented
    const isPresented =
      patient?.is_presented === "Yes" ||
      patient?.queueDetails?.is_presented === "Yes";
  
    if (isPresented) return true;
  
    return false;
  };
  // Helper function to show scan patient alert
  const showScanPatientAlert = (patient) => {
    if (patient?.partnerDetails?.questionnaire_filled === "No") {
      Swal.fire({
        title: "Partner Form Pending",
        text: "Please send the partner form link and complete the partner questionnaire before proceeding.",
        icon: "warning",
        confirmButtonText: "OK",
        confirmButtonColor: "#3085d6",
      });
      return;
    }
    Swal.fire({
      title: "Patient Not in Queue",
      text: "Please scan the patient QR code first to add them to the queue before performing this action.",
      icon: "warning",
      confirmButtonText: "OK",
      confirmButtonColor: "#3085d6",
    });
  };

  // Helper function to show pause alert
  const showPauseAlert = () => {
    Swal.fire({
      title: "Queue is Paused",
      text: "The patient queue is currently paused. Please resume the queue to perform this action.",
      icon: "warning",
      confirmButtonText: "OK",
      confirmButtonColor: "#3085d6",
    })
  }

  // ✅ SEND PARTNER FORM LINK HANDLER
  const handleSendPartnerFormLink = async (patient) => {

    if (!patient.partnerDetails?.patient_id) {
  
      Swal.fire({
        title: "Error",
        text: "Partner information not available",
        icon: "error",
        confirmButtonColor: "#3085d6",
      });
  
      return;
    }
  
    setSendingLinkPatientId(
      patient.partnerDetails.patient_id
    );
  
    try {
  
      await dispatch(
        sendFormLinkAction(
          patient.partnerDetails.patient_id
        )
      );
  
    } catch (error) {
  
    } finally {
  
      setTimeout(() => {
  
        setSendingLinkPatientId(null);
        setOpenShareMenuId(null);
  
      }, 1000);
  
    }
  
  };

  // ✅ CENTRALIZED APPOINTMENT STATE LOGIC
  const getAppointmentState = (appointment) => {
    // Case 4: No appointment exists
    if (appointment === null) {
      return {
        showConfirmButton: true,
        showAddToQueueButton: false,
        hideButtons: false,
        readonly: false,
        bookingMode: "new", // New booking
        modalTitle: "Book New Appointment"
      };
    }

    const isConfirmed = appointment?.is_confirmed === "Yes";
    const isPresented = appointment?.is_presented === "Yes";

    // ✅ CHECK CASE 3 FIRST (Most restrictive - both confirmed AND presented)
    if (isConfirmed && isPresented) {
      return {
        showConfirmButton: false,
        showAddToQueueButton: false,
        hideButtons: true,
        readonly: true,
        bookingMode: "complete",
        modalTitle: "Appointment Details"
      };
    }

    // Case 2: is_confirm === "Yes" && is_presented === "No"
    if (isConfirmed && !isPresented) {
      return {
        showConfirmButton: false,
        showAddToQueueButton: true,
        hideButtons: false,
        readonly: true,
        bookingMode: "queue",
        modalTitle: "Add to Queue"
      };
    }

    // Case 1: is_confirm === "No" && is_presented === "No"
    if (!isConfirmed && !isPresented) {
      return {
        showConfirmButton: true,
        showAddToQueueButton: false,
        hideButtons: false,
        readonly: false,
        bookingMode: "edit",
        modalTitle: "Confirm Appointment"
      };
    }

    // Default fallback
    return {
      showConfirmButton: true,
      showAddToQueueButton: false,
      hideButtons: false,
      readonly: false,
      bookingMode: "new",
      modalTitle: "Appointment Details"
    };
  };

  const handleSelectFile = (file, patient) => {
    if (file && patient?.patient_id) {
      const previewUrl = URL.createObjectURL(file);
      setPhotoPreviews((prev) => ({
        ...prev,
        [patient.patient_id]: previewUrl, // Store per patient
      }));
    }
  };

  const handlePatientSelect = async (patient) => {
    setSelectedPatient(patient);
    setSearchQuery(patient.patient_name);
    setShowSuggestions(false);

    // Fetch appointment details for the selected patient from search
    const appointmentData = await fetchAppointmentDetailsForPatient(patient.patient_id);

    if (appointmentData) {
      // Bind appointment details from API response
      console.log("[v0] Binding appointment data to modal:", appointmentData);
      setAppointmentDetails(appointmentData);
      
      // Bind doctor_id from appointment details
      const appointmentDoctorId = appointmentData?.doctor_id;
      setModalDoctorId(appointmentDoctorId || "");

      // Bind date from appointment details
      const appointmentDate = appointmentData?.date;
      setModalDate(appointmentDate || new Date().toISOString().split("T")[0]);

      // Bind time_slot from appointment details
      if (appointmentData?.time_slot) {
        setModalTimeSlot({
          value: appointmentData.time_slot,
          label: appointmentData.time_slot,
          branch_id: appointmentData.branch_id,       
          branch_name: appointmentData.branch_name, 
        });
      } else {
        setModalTimeSlot(null);
      }
    } else {
      // No appointment found - create new one with defaults
      console.log("[v0] No appointment data found, opening new appointment form");
      setModalDoctorId(patient.doctor_id || "");
      setModalDate(new Date().toISOString().split("T")[0]);
      setModalTimeSlot(null);
    }

    // Open modal
    setShowSlotModal(true);
  };
  const [highlightIndex, setHighlightIndex] = useState(-1);
  useEffect(() => {
    // Create doctor options from the doctors list
    const options = doctors.map((doctor) => ({
      value: doctor.doctor_id,
      label: doctor.doctor_name,
      specialization: doctor.specialization
    }));
    setModalDoctorOptions(options);
  }, [doctors]);
  const handleKeyDown = (e) => {
    if (!searchedPatients.length) return;

    if (e.key === "ArrowDown") {
      setHighlightIndex((prev) =>
        prev < searchedPatients.length - 1 ? prev + 1 : prev
      );
    }

    if (e.key === "ArrowUp") {
      setHighlightIndex((prev) => (prev > 0 ? prev - 1 : 0));
    }

    if (e.key === "Enter" && highlightIndex >= 0) {
      handlePatientSelect(searchedPatients[highlightIndex]);
    }
  };

  useEffect(() => {
    if (doctors && doctors.length > 0 && !selectedDoctorId) {
      const firstDoctor = doctors[0];
      const firstDoctorOption = {
        value: firstDoctor.doctor_id,
        label: firstDoctor.doctor_name,
        specialization: firstDoctor.specialization,
      };

      setSelectedDoctorOption(firstDoctorOption);
      setSelectedDoctorId(firstDoctor.doctor_id);

      const today = getTodayDate();
      dispatch(getBookedAppointmentsAction(today, firstDoctor.doctor_id));
    }
  }, [doctors, selectedDoctorId, dispatch]);
  const handleModalDoctorChange = (selectedOption) => {
    setModalDoctorId(selectedOption?.value || "");
    setModalTimeSlot(null); // Reset time slot when doctor changes
    setSlotsData([]); // Immediately clear slots when doctor changes
  };

  const handleRescheduleModalDoctorChange = (selectedOption) => {
    setRescheduleModalDoctorId(selectedOption?.value || "");
    setRescheduleModalTimeSlot(null); // Reset time slot when doctor changes
    setRescheduleSlotsData([]); // Immediately clear slots when doctor changes
  };

  // Helper function to check if patient is the last patient and no more patients in queue
  const isLastPatientInQueue = (patient) => {
    const queuePatients = patients.filter((p) => p.status !== "Current")
    return queuePatients.length === 0 && patient.status === "Current"
  }

  const handleDoctorChange = async (selectedOption) => {
    const doctorId = selectedOption?.value
    setSelectedDoctorId(doctorId)
    setSelectedDoctorOption(selectedOption)
    setRightPanelLoading(true)
    try {
      const today = getTodayDate()
      await Promise.all([
        dispatch(getBookedAppointmentsAction(today, doctorId, "Yes")),
        dispatch(getBookedAppointmentsAction(today, doctorId, "No")),
      ])
    } catch (err) {
      console.error("Doctor change fetch error:", err)
    } finally {
      setRightPanelLoading(false)
    }
  }

  const formatOptionLabel = ({ label, specialization }) => (
    <div>
      <div style={{ fontWeight: "bold" }}>{label}</div>
      <div style={{ fontSize: "0.8em", color: "#666" }}>{specialization}</div>
    </div>
  )

  const selectedDoctor = doctors.find((doc) => doc.doctor_id === selectedDoctorId)
  const selectedDoctorValue = selectedDoctor
    ? {
      value: selectedDoctor.doctor_id,
      label: selectedDoctor.doctor_name,
      specialization: selectedDoctor.specialization,
    }
    : null

  useEffect(() => {
    dispatch(getDoctorsAction()), dispatch(fetchReceptionistDashboardAction())
  }, [dispatch])

  const customStyles = {
    option: (provided) => ({
      ...provided,
      display: "flex",
      flexDirection: "column",
      padding: "10px",
    }),
    singleValue: (provided) => ({
      ...provided,
      display: "flex",
      flexDirection: "column",
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
      position: "absolute",
    }),
    control: (provided) => ({
      ...provided,
      zIndex: 999,
      height: "50px",
      minHeight: "40px",
    }),
    container: (provided) => ({
      ...provided,
      position: "relative",
      zIndex: 1000,
    }),
  }

  useEffect(() => {
    if (vitalsPatient) {
      setShowVitalsModal(true)
    }
  }, [vitalsPatient])

  // Use selected doctor appointments for right panel, fallback to all doctors if no selection
  const patients = useSelector((state) => {
    if (selectedDoctorId && selectedDoctorId !== 0 && String(selectedDoctorId) !== "0") {
      return state.receptionists?.selectedDoctorAppointments || [];
    }
    return state.receptionists?.bookedAppointments || [];
  })
  console.log("Patients List: ", patients)

  const totalAppointments = dashboardData.TotalAppointment || 0
  const onlineAppointments = dashboardData.OnlineAppointments || 0
  const offlineAppointments = dashboardData.OfflineAppointments || 0
  const pendingPatientQueue = dashboardData.PendingPatientQueue || 0
  const currentPatient = useMemo(() => {
    return patients.find(p => p.status === "Current") || null;
  }, [patients]);

  const nextPatient = patients.find(p => p.status === "Next");

  const waitingPatients = patients.filter(
    p => p.status === "Waiting"
  );



  const getTodayDate = () => {
    const today = new Date()
    return today.toISOString().split("T")[0]
  }

  const handleUploadPatientPhoto = async (patient, file) => {
    if (!patient?.patient_id || !file) return;

    setActionLoading(prev => ({ ...prev, uploadingPhoto: patient.patient_id }));

    try {
      await dispatch(uploadPatientPhotoAction(patient.patient_id, file));

      Swal.fire({
        icon: "success",
        title: "Photo Uploaded",
        text: "Patient photo uploaded successfully!",
        timer: 1500,
        showConfirmButton: false,
      });

      // Refresh appointments
      const today = getTodayDate();
      dispatch(getBookedAppointmentsAction(today, selectedDoctorId || 0));

    } catch (error) {
      console.error("Photo upload error:", error);
      Swal.fire("Error", "Failed to upload photo", "error");
    } finally {
      setActionLoading(prev => ({ ...prev, uploadingPhoto: null }));
    }
  };

  const handleBackToQueue = async (patient) => {
    if (!patient?.queue_id) return;

    setActionLoading(prev => ({ ...prev, backToQueue: patient.queue_id }));

    try {
      await dispatch(addBackToQueueAction(patient.queue_id));

  

      // Refresh list
      const today = getTodayDate();
      dispatch(
        getBookedAppointmentsAction(
          today,
          selectedDoctorId || null
        )
      );

    } catch (error) {
      console.error("Back to queue error:", error);
      Swal.fire("Error", "Failed to add back to queue", "error");
    } finally {
      setActionLoading(prev => ({ ...prev, backToQueue: null }));
    }
  };

  useEffect(() => {
    const fetchAppointmentsInterval = async () => {
      try {
        const date = getTodayDate();
        const currentSelectedDoctor = selectedDoctorId || doctorId || admin_id;

        // STEP 1: Fetch doctor_id = 0 (ALL DOCTORS - Yes + No)
        const allDoctorsCalls = [
          dispatch(getBookedAppointmentsAction(date, selectedDoctorId, "Yes")),
          dispatch(getBookedAppointmentsAction(date, selectedDoctorId, "No")),
        ];

        // STEP 2: If a doctor is selected, also fetch their data to keep it fresh
        const selectedDoctorCalls = [];
        if (currentSelectedDoctor && currentSelectedDoctor !== 0 && String(currentSelectedDoctor) !== "0") {
          selectedDoctorCalls.push(
            dispatch(getBookedAppointmentsAction(date, currentSelectedDoctor, "Yes")),
            dispatch(getBookedAppointmentsAction(date, currentSelectedDoctor, "No"))
          );
        }

        // Execute all fetches in parallel
        await Promise.all([...allDoctorsCalls, ...selectedDoctorCalls]);
      } catch (error) {
        console.error("Failed to fetch appointments:", error);
      }
    };

    // First Load
    fetchAppointmentsInterval();

    // Poll every 5 seconds
    const interval = setInterval(fetchAppointmentsInterval, 3000);

    return () => clearInterval(interval);
  }, [dispatch, selectedDoctorId, doctorId, admin_id]);

  const handleHeightChange = (e) => {
    const value = e.target.value
    setVitalsPatient((prev) => {
      const weight = prev?.weight || 0
      const heightInM = value / 100
      const bmiValue = weight && value ? (weight / (heightInM * heightInM)).toFixed(2) : ""
      return {
        ...prev,
        height: value,
        bmi: bmiValue,
      }
    })
  }// Height in CM change
  const handleHeightCmChange = (e) => {
    const value = parseFloat(e.target.value) || 0

    // convert cm → feet + inches
    const totalInches = value / 2.54
    const feet = Math.floor(totalInches / 12)
    const inches = Math.round(totalInches % 12)

    setVitalsPatient((prev) => {
      const weight = parseFloat(prev?.weight) || 0
      const heightInM = value / 100
      const bmiValue = weight && value ? (weight / (heightInM * heightInM)).toFixed(2) : ""

      return {
        ...prev,
        height: value, // in cm
        heightFeet: feet,
        heightInches: inches,
        bmi: bmiValue,
      }
    })
  }

  // Height in FEET change
  const handleHeightFeetChange = (e) => {
    const feet = parseFloat(e.target.value) || 0
    setVitalsPatient((prev) => {
      const inches = parseFloat(prev?.heightInches) || 0
      const cm = ((feet * 12) + inches) * 2.54
      const weight = parseFloat(prev?.weight) || 0
      const heightInM = cm / 100
      const bmiValue = weight && cm ? (weight / (heightInM * heightInM)).toFixed(2) : ""

      return {
        ...prev,
        heightFeet: feet,
        height: cm,
        bmi: bmiValue,
      }
    })
  }

  // Height in INCHES change
  const handleHeightInchesChange = (e) => {
    const inches = parseFloat(e.target.value) || 0
    setVitalsPatient((prev) => {
      const feet = parseFloat(prev?.heightFeet) || 0
      const cm = ((feet * 12) + inches) * 2.54
      const weight = parseFloat(prev?.weight) || 0
      const heightInM = cm / 100
      const bmiValue = weight && cm ? (weight / (heightInM * heightInM)).toFixed(2) : ""

      return {
        ...prev,
        heightInches: inches,
        height: cm,
        bmi: bmiValue,
      }
    })
  }


  const handleVitalsChange = (e) => {
    const { name, value, files } = e.target
    setVitalsPatient((prev) => ({
      ...prev,
      [name]: files ? files[0] : value,
    }))
  }

  const handleVitalsOpen = (patient) => {
    if (!patient) return;

    // Check if patient can perform actions
    if (!canPerformActions(patient)) {
      showScanPatientAlert(patient);
      return;
    }

    // Get the ID to use for loading state (queue_id preferred, fallback to patient_id)
    const loadingId = getLoadingId(patient);
    if (!loadingId) {
      console.error("No valid ID found for patient", patient);
      return;
    }

    // Don't set loading if already opening this patient
    if (actionLoading.vitalsOpening === loadingId) return;

    // Store the ID
    setActionLoading(prev => ({ ...prev, vitalsOpening: loadingId }));

    setShowVitalsModal(true); // Open modal immediately

    const keyMap = {
      systolic_bp: "systolicBP",
      diastolic_bp: "diastolicBP",
      Oxygen_Saturation: "oxygenSaturation",
      blood_glucose_level: "bloodGlucose",
      pluse_rate: "pulseRate",
      temperature: "temperature",
      Allergies: "allergies",
      weight: "weight",
      height: "height",
      bmi: "bmi",
    };

    // Initialize with queue_id from patient
    const transformedPatient = {
      queue_id: patient.queue_id,
    };

    for (const key in keyMap) {
      if (patient[key] !== undefined && patient[key] !== null) {
        transformedPatient[keyMap[key]] = patient[key];
      }
    }

    // �� Convert cm → feet/inches if height exists
    if (transformedPatient.height) {
      const totalInches = transformedPatient.height / 2.54;
      const feet = Math.floor(totalInches / 12);
      const inches = Math.round(totalInches % 12);
      transformedPatient.heightFeet = feet;
      transformedPatient.heightInches = inches;
    }

    // ✅ Handle Reports_Upload properly
    if (patient.Reports_Upload) {
      const fileName = patient.Reports_Upload.split("/").pop();
      transformedPatient.uploadedFileName = fileName;
      setUploadedFiles([{ name: fileName, url: patient.Reports_Upload, isExisting: true }]);
    } else {
      transformedPatient.uploadedFileName = null;
      setUploadedFiles([]);
    }

    transformedPatient.uploadedFile = null;

    setVitalsPatient(transformedPatient);

    // Optional: Still set localStorage for backward compatibility with other parts
    localStorage.setItem("queue_id", patient.queue_id);
  }


  const handleVitalsClose = () => {
    setShowVitalsModal(false);
    setVitalsPatient(null);
    setUploadedFiles([]);
    // Clear loading state when modal is closed
    setActionLoading(prev => ({ ...prev, vitalsOpening: null }));
  }

  const handleConfirmSlot = async () => {

    console.log("selected patient >>>>> ", selectedPatient);

    // ✅ CASE 3: PREVENT API CALL IF ALREADY PRESENTED


    if (!modalDoctorId) {
      Swal.fire("Warning", "Please select a doctor", "warning");
      return;
    }

    if (!modalDate) {
      Swal.fire("Warning", "Please select a date", "warning");
      return;
    }

    if (!modalTimeSlot?.value) {
      Swal.fire("Warning", "Please select a time slot", "warning");
      return;
    }

    if (!selectedPatient?.patient_id) {
      Swal.fire("Error", "Patient not selected", "error");
      return;
    }

    // Prevent double click
    if (actionLoading.confirmingSlot) return;

    setActionLoading(prev => ({ ...prev, confirmingSlot: true }));

    try {
      await dispatch(
        addSearchPatientQueueAction(
          appointmentDetails?.appointment_id,
          selectedPatient.patient_id,
          modalDoctorId,
          modalTimeSlot.value,
          modalDate,
          modalTimeSlot.branch_id  
        )
      );

      handleSuccess("Patient added to queue successfully!");

      // Close modal
      setShowSlotModal(false);

      // Clear search input
      setSearchQuery("");
      setSelectedPatient(null);

      const today = getTodayDate();
      dispatch(
        getBookedAppointmentsAction(
          today,
          selectedDoctorId || modalDoctorId
        )
      );

    } catch (error) {
      console.error("Add queue error:", error);
      showErrorAlert("Failed to add patient to queue");
    } finally {
      setActionLoading(prev => ({ ...prev, confirmingSlot: false }));
    }
  };

  const handleConfirmReschedule = async () => {
    if (!rescheduleModalDoctorId) {
      Swal.fire("Warning", "Please select a doctor", "warning");
      return;
    }

    if (!rescheduleModalDate) {
      Swal.fire("Warning", "Please select a date", "warning");
      return;
    }

    if (!rescheduleModalTimeSlot) {
      Swal.fire("Warning", "Please select a time slot", "warning");
      return;
    }

    if (!selectedAppointmentForReschedule?.patient_id) {
      Swal.fire("Error", "Patient not selected", "error");
      return;
    }

    // Prevent double click
    if (actionLoading.reschedulingSlot) return;

    setActionLoading(prev => ({ ...prev, reschedulingSlot: true }));

    try {
      // Use the same API as confirm booking (addSearchPatientQueueAction)
      const patientId = selectedAppointmentForReschedule.patient_id;
      const newDoctorId = rescheduleModalDoctorId;
      const newTimeSlot = rescheduleModalTimeSlot.value;
      const newDate = rescheduleModalDate;
      const branchId = rescheduleModalTimeSlot.branch_id;

      console.log("[v0] Rescheduling appointment with params:", {
        patientId,
        newDoctorId,
        newTimeSlot,
        newDate,
        branchId
      });

      // Call the same API as confirm booking
      await dispatch(
        addSearchPatientQueueAction(
          patientId,
          newDoctorId,
          newTimeSlot,
          newDate,
          branchId
        )
      );

      handleSuccess("Appointment rescheduled successfully!");

      // Close modal and reset states
      setShowRescheduleModal(false);
      setSelectedAppointmentForReschedule(null);
      setRescheduleModalDoctorId("");
      setRescheduleModalDate(today);
      setRescheduleModalTimeSlot(null);
      setAppointmentDetails(null);

      // Refresh appointments
      const currentDate = selectedDate || getTodayDate();
      dispatch(
        getBookedAppointmentsAction(
          currentDate,
          selectedDoctorId || newDoctorId
        )
      );

    } catch (error) {
      console.error("Reschedule error:", error);
      showErrorAlert("Failed to reschedule appointment");
    } finally {
      setActionLoading(prev => ({ ...prev, reschedulingSlot: false }));
    }
  };

  const handleWeightChange = (e) => {
    const value = e.target.value
    setVitalsPatient((prev) => {
      const height = prev?.height || 0
      const heightInM = height / 100
      const bmiValue = value && height ? (value / (heightInM * heightInM)).toFixed(2) : ""
      return {
        ...prev,
        weight: value,
        bmi: bmiValue,
      }
    })
  }

  const handleFileChange = (e) => {
    const file = e.target.files[0] // Only take the first file
    const validTypes = ["image/jpeg", "image/png"]

    if (file && validTypes.includes(file.type)) {
      setVitalsPatient((prev) => ({
        ...prev,
        uploadedFile: file, // Store the actual file object here (singular)
        uploadedFileName: file.name, // Store the name for display
      }))
      setUploadedFiles([file]) // Update the `uploadedFiles` state for the table display
    } else {
      alert("Only JPEG and PNG files are allowed.")
      e.target.value = null // Clear the input field
      setVitalsPatient((prev) => ({ ...prev, uploadedFile: null, uploadedFileName: null }))
      setUploadedFiles([])
    }
  }

  const handleDelete = (index) => {
    const updatedFiles = [...uploadedFiles]
    updatedFiles.splice(index, 1)
    setUploadedFiles(updatedFiles)
    // Also clear the file from vitalsPatient if it was the one selected
    setVitalsPatient((prev) => ({ ...prev, uploadedFile: null, uploadedFileName: null }))
    const fileInput = document.getElementById("reports")
    if (fileInput) fileInput.value = ""
  }

  const handleSendReminder = async (appointmentId) => {
    if (!appointmentId) return;

    if (actionLoading.sendingReminder === appointmentId) return;
    console.log("appoinmnte=============================", appointmentId)

    setActionLoading(prev => ({ ...prev, sendingReminder: appointmentId }));

    try {
      await dispatch(sendReminderAction(appointmentId));

      // Wait 5 seconds then refresh appointments to get updated data with proper date formatting
      setTimeout(() => {
        const today = selectedDate || getTodayDate();
        dispatch(
          getBookedAppointmentsAction(
            today,
            selectedDoctorId || null
          )
        );
      }, 5000);

      // handleSuccess("Reminder sent successfully!");

    } catch (err) {
      console.error("Reminder error:", err);
      showErrorAlert("Failed to send reminder");
    } finally {
      setActionLoading(prev => ({ ...prev, sendingReminder: null }));
    }
  };

  const handleReschedule = async (appointment) => {
    if (!appointment) return;
    
    // Set the selected appointment
    setSelectedAppointmentForReschedule(appointment);
    
    // Fetch appointment details to get current booking info
    setFetchingAppointmentDetails(true);
    try {
      const appointmentData = await fetchAppointmentDetailsForPatient(appointment.patient_id);
      
      if (appointmentData) {
        console.log("[v0] Appointment details for reschedule:", appointmentData);
        
        // Initialize reschedule modal with fetched appointment data
        setRescheduleModalDoctorId(appointmentData.doctor_id || appointment.doctor_id || "");
        setRescheduleModalDate(appointmentData.date || appointmentData.appointment_date || today);
        setRescheduleModalTimeSlot(null);
        setRescheduleSlotsData([]);
        setAppointmentDetails(appointmentData); // Set appointment details for modal display
      } else {
        // Fallback to appointment object data if no details fetched
        setRescheduleModalDoctorId(appointment.doctor_id || "");
        setRescheduleModalDate(appointment.date || appointment.appointment_date || today);
        setRescheduleModalTimeSlot(null);
        setRescheduleSlotsData([]);
        setAppointmentDetails(null);
      }
    } catch (error) {
      console.error("[v0] Error fetching appointment details for reschedule:", error);
      // Fallback to appointment object data
      setRescheduleModalDoctorId(appointment.doctor_id || "");
      setRescheduleModalDate(appointment.date || appointment.appointment_date || today);
      setRescheduleModalTimeSlot(null);
      setRescheduleSlotsData([]);
      setAppointmentDetails(null);
    } finally {
      setFetchingAppointmentDetails(false);
    }
    
    // Set mode to reschedule and open the modal
    setModalMode("reschedule");
    setShowRescheduleModal(true);
  };

  const resetSlotModalStates = () => {
    // Reset all appointment modal states
    setModalMode(null);
    setSelectedPatient(null);
    setAppointmentDetails(null);
    setModalDoctorId("");
    setModalDate(today);
    setModalTimeSlot(null);
    setSlotsData([]);
  };

  const resetRescheduleModalStates = () => {
    // Reset all reschedule modal states
    setModalMode(null);
    setSelectedAppointmentForReschedule(null);
    setRescheduleModalDoctorId("");
    setRescheduleModalDate(today);
    setRescheduleModalTimeSlot(null);
    setRescheduleSlotsData([]);
    setAppointmentDetails(null);
    setFetchingAppointmentDetails(false);
  };

  const handleView = (file) => {
    // Reset modal state before opening preview

    if (file.isExisting && file.url) {
      window.open(file.url, "_blank")
    } else if (file instanceof File) {
      const fileURL = URL.createObjectURL(file)
      window.open(fileURL, "_blank")
    } else {
      Swal.fire("Warning", "Cannot view this file type or URL is not available.", "warning")
    }
  }

  const [cameraError, setCameraError] = useState(false)

  // Fetch appointment details for a patient
  const fetchAppointmentDetailsForPatient = async (patientId) => {
    setFetchingAppointmentDetails(true);
  
    try {
      const response = await axiosInstance.post("/patient/appointmentDetails", {
        patient_id: patientId
      });
  
      const appointmentData = response?.data?.data ?? null;
  
      setAppointmentDetails(appointmentData); // ✅ always set
  
      return appointmentData;
  
    } catch (error) {
      console.error("Error fetching appointment details:", error);
      setAppointmentDetails(null);
      return null;
    } finally {
      setFetchingAppointmentDetails(false);
    }
  };

  // Handle appointment flow based on appointment status
  const handleAppointmentFlow = async (qrcodescanData, patientId) => {
 
    console.log("PATIENT >>>> ", patientId);
    const patientData = JSON.parse(patientId);
    const appointmentData = await fetchAppointmentDetailsForPatient(patientData.id);
    const patientDetails = { patient_id: patientData.id, patient_name: patientData.name };
    setSelectedPatient(patientDetails);

    console.log( appointmentData , "================= appointment data for patient after scanning +++++++");

    // ✅ CASE 3: ALREADY PRESENTED - PREVENT RE-QUEUE
    // If appointment is confirmed AND presented, show message and return early
    if (appointmentData?.is_confirmed === "Yes" && appointmentData?.is_presented === "Yes") {
      Swal.fire({
        title: "Patient Already in Queue",
        text: "This patient has already been added to the queue.",
        icon: "info",
        confirmButtonText: "OK",
      });
      return; // Early exit - prevent queue API call and duplicate addition
    }

    // Appointment is confirmed - proceed with direct scanning
    console.log("Appointment confirmed, proceeding with scan");
      
    const queueDetails = await dispatch(createReceptionistAction(qrcodescanData, selectedDoctorId || 0));

    console.log("Queue details after scanning:", queueDetails, " ++++ ", typeof queueDetails);

    if (queueDetails == null) return;

    var doctorId = 0;
    var appointmentDate = today;
    var timeSlot = null;

    if (appointmentData) {

      // CASE 3
      if (
        appointmentData?.is_confirmed === "Yes" &&
        appointmentData?.is_presented === "Yes"
      ) {
    
        Swal.fire({
          title: "Patient Already in Queue",
          text: "This patient has already been added to the queue.",
          icon: "info",
          confirmButtonText: "OK",
        });
    
        setShowSlotModal(false);
    
        return;
      }
    
      // CASE 2
      if (
        appointmentData?.is_confirmed === "Yes" &&
        appointmentData?.is_presented === "No"
      ) {
    
        doctorId = appointmentData.doctor_id || "";
        appointmentDate = appointmentData.date || today;
    
        timeSlot = {
          value: appointmentData.time_slot,
          label: appointmentData.time_slot,
          branch_id: appointmentData.branch_id,
          branch_name: appointmentData.branch_name,
        };
      }
    
      // CASE 1
      if (
        appointmentData?.is_confirmed === "No" &&
        appointmentData?.is_presented === "No"
      ) {
    
        doctorId = appointmentData.doctor_id || "";
        appointmentDate = appointmentData.date || today;
    
        timeSlot = appointmentData.time_slot
          ? {
              value: appointmentData.time_slot,
              label: appointmentData.time_slot,
              branch_id: appointmentData.branch_id,
              branch_name: appointmentData.branch_name,
            }
          : null;
      }
    }

    setModalDoctorId(doctorId);
    setModalDate(appointmentDate);
    setModalTimeSlot(timeSlot);
    setAppointmentDetails(appointmentData); // Set appointment details for modal display
    setModalMode("appointment"); // Set mode to appointment (QR scan flow)
    setShowSlotModal(true); // Open the appointment modal, NOT reschedule modal
    
    const todayDate = getTodayDate();
    await dispatch(getBookedAppointmentsAction(todayDate, selectedDoctorId || 0));
  
    await dispatch(upcomingAppointmentAction());    
    
  };

  const handleScanSuccess = async (qrcodescanData) => {
    const hasPatients = patients && patients.length > 0
    setActionLoading(prev => ({ ...prev, scanning: true }));
    setShowScanner(false)
    try {
      // Extract patient_id from QR code data (assuming it's the patient_id)
      const patientId = qrcodescanData;
      
      // Fetch appointment details and handle flow
      await handleAppointmentFlow(qrcodescanData, patientId);
    } catch (error) {
      console.error("Error scanning patient:", error)
      Swal.fire("Error", "Failed to scan patient. Please try again.", "error")
    } finally {
      setActionLoading(prev => ({ ...prev, scanning: false }));
    }
  }

  const checkCameraPermissions = async () => {
    if (!selectedDoctorValue || !selectedDoctorValue.value) {
      setDoctorError("Please select the doctor before scanning")
      return
    }
    setDoctorError("")

    const hasPatients = patients && patients.length > 0
    try {
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        throw new Error("Camera API not supported")
      }
      const stream = await navigator.mediaDevices.getUserMedia({ video: true })
      stream.getTracks().forEach((track) => track.stop())
      setShowScanner(true)
      setCameraError(false)
    } catch (err) {
      console.error("Camera permission denied:", err)
      setCameraError(true)
      Swal.fire({
        title: "Camera Access Required",
        text: "Please enable camera permissions to scan QR codes",
        icon: "warning",
        confirmButtonText: "OK",
      })
    }
  }

  useEffect(() => {
    let scanner
    let isMounted = true
    const startScanner = async () => {
      try {
        scanner = new Html5Qrcode("qr-reader")
        const config = {
          fps: 10,
          qrbox: { width: 250, height: 250 },
        }
        const cameraConfig = { facingMode: "user" }
        await scanner.start(
          cameraConfig,
          config,
          (decodedText) => {
            if (isMounted) {
              handleScanSuccess(decodedText)
            }
          },
          (error) => {
            if (isMounted) {
              console.log("Trying environment camera...")
              scanner.start(
                { facingMode: "environment" },
                config,
                (decodedText) => {
                  if (isMounted) {
                    handleScanSuccess(decodedText)
                    scanner.stop().then(() => {
                      document.getElementById("qr-reader").innerHTML = ""
                    })
                  }
                },
                (error) => {
                  if (isMounted) {
                    console.error("QR scanner error:", error)
                    Swal.fire("Error", "Could not access any camera. Please check permissions.", "error")
                    setShowScanner(false)
                  }
                },
              )
            }
          },
        )
      } catch (err) {
        if (isMounted) {
          console.error("QR scanner start error", err)
          Swal.fire("Error", "Could not start scanner. Please check camera permissions.", "error")
          setShowScanner(false)
        }
      }
    }
    if (showScanner && !cameraError) {
      startScanner()
    }
    return () => {
      isMounted = false
      if (scanner) {
        scanner
          .stop()
          .then(() => {
            document.getElementById("qr-reader").innerHTML = ""
          })
          .catch((err) => {
            console.error("Error stopping scanner:", err)
          })
      }
    }
  }, [showScanner, cameraError])

  const handleOnSubmit = async (e) => {
    e.preventDefault()

    if (submittingVitals) return

    const v = vitalsPatient || {}

    const allEmpty =
      (!v.systolicBP || v.systolicBP === 0) &&
      (!v.diastolicBP || v.diastolicBP === 0) &&
      (!v.weight || v.weight === 0) &&
      (!v.height || v.height === 0) &&
      (!v.bmi || v.bmi === 0) &&
      (!v.pulseRate || v.pulseRate === 0) &&
      (!v.temperature || v.temperature === 0) &&
      (!v.oxygenSaturation || v.oxygenSaturation === 0) &&
      (!v.bloodGlucose || v.bloodGlucose === 0) &&
      (!v.allergies || v.allergies.trim() === "")

    if (allEmpty) {
      Swal.fire("Warning", "Please enter at least one vital before saving.", "warning")
      return
    }

    // Use queue_id from state FIRST, fallback to localStorage
    const queueId = v.queue_id || localStorage.getItem("queue_id")

    if (!queueId) {
      Swal.fire("Error", "No patient selected for vitals.", "error")
      return
    }

    console.log("Submitting vitals with queue_id:", queueId) // Debug log

    setSubmittingVitals(true)

    const dataToSend = { queue_id: queueId }
    if (v.systolicBP) dataToSend.systolicBP = v.systolicBP
    if (v.diastolicBP) dataToSend.diastolicBP = v.diastolicBP
    if (v.oxygenSaturation) dataToSend.oxygenSaturation = v.oxygenSaturation
    if (v.bloodGlucose) dataToSend.bloodGlucose = v.bloodGlucose
    if (v.weight) dataToSend.weight = v.weight
    if (v.height) dataToSend.height = v.height
    if (v.bmi) dataToSend.bmi = v.bmi
    if (v.pulseRate) dataToSend.pulseRate = v.pulseRate
    if (v.temperature) dataToSend.temperature = v.temperature
    if (v.allergies) dataToSend.allergies = v.allergies.trim()

    if (v.uploadedFile) dataToSend.Reports_Upload = v.uploadedFile
    else if (v.uploadedFileName) dataToSend.Reports_Upload = v.uploadedFileName
    else dataToSend.Reports_Upload = null

    try {
      await dispatch(addVitalsAction(dataToSend))
      handleSuccess( "Vitals added successfully!")
      setShowVitalsModal(false)
      setUploadedFiles([])
      setVitalsPatient(null)
      localStorage.removeItem("queue_id") // Clean up localStorage
      const today = getTodayDate()
      dispatch(getBookedAppointmentsAction(today, selectedDoctorId || 0))
      // Clear loading state after successful save
      setActionLoading(prev => ({ ...prev, vitalsOpening: null }));
    } catch (err) {
      console.error("Error adding vitals:", err)
      showErrorAlert( "Failed to add vitals")
    } finally {
      setSubmittingVitals(false)
    }
  }

  const handleMarkNext = async (patient) => {
    // Check if patient can perform actions
    if (!canPerformActions(patient)) {
      showScanPatientAlert(patient);
      return;
    }

    // Get the ID to use for loading state (queue_id preferred, fallback to patient_id)
    const loadingId = getLoadingId(patient);
    if (!loadingId) {
      console.error("No valid ID found for patient", patient);
      return;
    }

    // ⛔ Vitals validation
    const isVitalsMissing =
      (!patient.systolic_bp || patient.systolic_bp === "0") &&
      (!patient.diastolic_bp || patient.diastolic_bp === "0") &&
      (!patient.weight || patient.weight === "0") &&
      (!patient.height || patient.height === "0") &&
      (!patient.bmi || patient.bmi === "0") &&
      (!patient.pluse_rate || patient.pluse_rate === "0") &&
      (!patient.temperature || patient.temperature === "0") &&
      (!patient.Oxygen_Saturation || patient.Oxygen_Saturation === "0") &&
      (!patient.blood_glucose_level || patient.blood_glucose_level === "0") &&
      (!patient.Allergies || patient.Allergies === "") &&
      (!patient.Reports_Upload || patient.Reports_Upload === "");

    if (isVitalsMissing) {
      Swal.fire({
        icon: "warning",
        title: "Vitals Not Added",
        text: "Please add vitals before marking patient as Next.",
      });
      return;
    }

    // ⏸ queue paused
    if (isPaused) {
      showPauseAlert();
      return;
    }

    // Prevent double clicks
    if (actionLoading.markingNext === loadingId) return;

    setActionLoading(prev => ({ ...prev, markingNext: loadingId }));

    try {
      await dispatch(markPatientNextAction(patient.queue_id));
      const today = getTodayDate();
      await dispatch(getBookedAppointmentsAction(today, selectedDoctorId || 0));
      handleSuccess(
        "Patient Marked as Next",
        `${patient.name} is now the next patient.`
      );

    } catch (err) {
      console.error("Mark next failed", err);
      showErrorAlert("Failed to mark patient as next");
    } finally {
      setActionLoading(prev => ({ ...prev, markingNext: null }));
    }
  };

  const handleMarkCurrent = async (patient) => {
    // Check if patient can perform actions
    if (!canPerformActions(patient)) {
      showScanPatientAlert(patient);
      return;
    }

    // Get the ID to use for loading state (queue_id preferred, fallback to patient_id)
    const loadingId = getLoadingId(patient);
    if (!loadingId) {
      console.error("No valid ID found for patient", patient);
      return;
    }

    // ⛔ RESTRICTION: If vitals are missing, block action
    const isVitalsMissing =
      (!patient.systolic_bp || patient.systolic_bp === "0") &&
      (!patient.diastolic_bp || patient.diastolic_bp === "0") &&
      (!patient.weight || patient.weight === "0") &&
      (!patient.height || patient.height === "0") &&
      (!patient.bmi || patient.bmi === "0") &&
      (!patient.pluse_rate || patient.pluse_rate === "0") &&
      (!patient.temperature || patient.temperature === "0") &&
      (!patient.Oxygen_Saturation || patient.Oxygen_Saturation === "0") &&
      (!patient.blood_glucose_level || patient.blood_glucose_level === "0") &&
      (!patient.Allergies || patient.Allergies === "") &&
      (!patient.Reports_Upload || patient.Reports_Upload === "");

    if (isVitalsMissing) {
      Swal.fire({
        icon: "warning",
        title: "Vitals Not Added",
        text: "Please add vitals before marking patient as Current.",
      });
      return;
    }

    // ⏸ If queue paused
    if (isPaused) {
      showPauseAlert();
      return;
    }

    // Prevent double clicks
    if (actionLoading.markingCurrent === loadingId) return;

    setActionLoading(prev => ({ ...prev, markingCurrent: loadingId }));

    try {
      await dispatch(markPatientCurrentAction(patient.queue_id));
      const today = getTodayDate();
      await dispatch(getBookedAppointmentsAction(today, selectedDoctorId || 0));
      handleSuccess(
        "Patient Marked as Current",
        `${patient.name} is now the current patient.`
      );
    } catch (err) {
      console.error("Mark current failed", err);
      showErrorAlert("Failed to mark patient as current");
    } finally {
      setActionLoading(prev => ({ ...prev, markingCurrent: null }));
    }
  };

  const handleIconClick = () => {
    console.log("Icon clicked")
  }



  const upcomingAppointments = useSelector((state) => state.receptionists?.upcomingAppointments || [])

  const handleCancel = async (appointment) => {
    setActionLoading(prev => ({ ...prev, canceling: appointment.appointment_id }));

    try {
      const result = await Swal.fire({
        title: "Cancel Appointment",
        text: `Are you sure you want to cancel the appointment for ${appointment.name}?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Yes, cancel it!",
        cancelButtonText: "No, keep it",
      })

      if (result.isConfirmed) {
        const response = await cancelLeadAppointment(appointment.appointment_id)
        if (response.data?.status === "success") {
          handleSuccess(`The appointment for ${appointment.name} has been cancelled successfully.`)
          setTimeout(() => {
            dispatch(upcomingAppointmentAction(selectedDate))
          }, 1000)
        } else {
          showErrorAlert(response.data?.message || "Failed to cancel appointment")
        }
      }
    } catch (error) {
      console.error("Error cancelling appointment:", error)
      showErrorAlert("Something went wrong while cancelling the appointment.")
    } finally {
      setActionLoading(prev => ({ ...prev, canceling: null }));
    }
  }

  const [showModal, setShowModal] = useState(false)
  const [amount, setAmount] = useState("")
  const [paymentMode, setPaymentMode] = useState("Online")
  const [couponCode, setCouponCode] = useState("")
  const [finalAmount, setFinalAmount] = useState(null)

  const handleScanPatient = () => {
    const qrcodescanData = "some_scan_data"
    dispatch(createReceptionistAction(qrcodescanData))
  }

  const handlePaymentSubmit = async (paymentData) => {
    setActionLoading(prev => ({ ...prev, collectingPayment: true }));

    try {
      console.log("Submitting payment with data:", paymentData, "for patient:", selectedPatient)
      const formData = {
        queue_id: selectedPatient?.queue_id,
        patient_id: selectedPatient?.patient_id,
        amount: paymentData.amount,
        payment_type: paymentData.paymentType,
        payment_for: "APPOINTMENT",
        coupon_code: paymentData.couponCode || "",
        final_amount: paymentData.finalAmount,
        reference_id: selectedPatient?.id,
      }
      console.log("<========================Collected payement======================>", formData)
      const res = await dispatch(collectPaymentAction(formData))
      console.log("action response =============================>", res)
      handleSuccess("Payment collected successfully!")
      const today = getTodayDate()
      await dispatch(getBookedAppointmentsAction(today, selectedDoctorId || 0))
      setShowModal(false)
      setSelectedPatient(null)
    } catch (error) {
      console.error("Payment error:", error)
      showErrorAlert("Payment failed. Please try again.")
    } finally {
      setActionLoading(prev => ({ ...prev, collectingPayment: false }));
    }
  }

  const handleApplyCoupon = () => {
    const amt = Number.parseFloat(amount)
    if (!amt || amt <= 0) {
      Swal.fire({
        icon: "warning",
        title: "Invalid Amount",
        text: "Enter a valid amount before applying the coupon.",
      })
      return
    }
    if (couponCode.trim() === "") {
      Swal.fire({
        icon: "warning",
        title: "Invalid Coupon Code",
        text: "Please enter a valid coupon code.",
      })
      return
    }
    let discount = 0
    switch (couponCode.toUpperCase()) {
      case "ROHATI10":
        discount = 0.1
        break
      case "ROHATI20":
        discount = 0.2
        break
      case "ROHATI30":
        discount = 0.3
        break
      default:
        Swal.fire({
          icon: "error",
          title: "Invalid Coupon",
          text: "The entered coupon code is invalid.",
        })
        return
    }
    const discountAmount = amt * discount
    const finalAmt = amt - discountAmount
    setFinalAmount(finalAmt)
    Swal.fire({
      icon: "success",
      title: "Coupon Applied",
      text: `Discount of ${discount * 100}% applied. Final amount: ₹${finalAmt}`,
    })
  }

  const handleCollectPayment = (patient) => {
    console.log("Selected P{atient for payment:", patient )
    setSelectedPatient(patient)
    setShowModal(true)
    setAmount("")
    setPaymentMode("Online")
    setCouponCode("")
    setFinalAmount(null)
  }
  // Convert "09:30AM" or "02:15PM" → "09:30" or "14:15" for proper Date parsing
  const convertTo24Hour = (time12h) => {
    if (!time12h) return "00:00";
    const match = time12h.match(/(\d{1,2}):(\d{2})(AM|PM)/i);
    if (!match) return "00:00";
    let [, hours, minutes, meridian] = match;
    hours = parseInt(hours, 10);
    if (meridian.toUpperCase() === "PM" && hours !== 12) hours += 12;
    if (meridian.toUpperCase() === "AM" && hours === 12) hours = 0;
    return `${hours.toString().padStart(2, "0")}:${minutes}`;
  };

  const createLocalDate = (dateStr, timeStr) => {
    if (!dateStr || !timeStr) {
      console.warn("Invalid date/time input:", { dateStr, timeStr });
      return new Date(NaN); // invalid date
    }
    const converted = convertTo24Hour(timeStr);
    const [hours, minutes] = converted.split(":").map(Number);
    if (isNaN(hours) || isNaN(minutes)) return new Date(NaN);

    const [year, month, day] = dateStr.split("-").map(Number);
    if (!year || !month || !day) return new Date(NaN);

    return new Date(year, month - 1, day, hours, minutes, 0);
  };

  const handleRescheduleAppointment = async (appointment) => {
    console.log("Rescheduling appointment:", appointment);
    const appointmentId = appointment.appointment_id || appointment.queue_id;

    if (!appointment || !appointmentId) {
      await Swal.fire({
        title: "Invalid Appointment",
        text: "Cannot reschedule: Missing appointment information.",
        icon: "error",
        confirmButtonText: "OK",
      });
      return;
    }

    // ✅ Allow reschedule only once
    if (appointment?.reschedule_count >= 1) {
      await Swal.fire({
        icon: "warning",
        title: "Reschedule Not Allowed",
        text: "This appointment has already been rescheduled once.",
      });
      return;
    }

    // ✅ Proper 48-hour check
    const [timePart] = appointment.time_slot?.split(" to ") || [];
    if (!timePart) {
      await Swal.fire({
        icon: "error",
        title: "Invalid Appointment Time",
        text: "Cannot reschedule: Appointment time is missing or invalid.",
      });
      return;
    }

    const appointmentDate = createLocalDate(appointment.date, timePart);
    const diffHours = (appointmentDate - new Date()) / (1000 * 60 * 60);

    if (isNaN(diffHours) || diffHours < 48) {
      await Swal.fire({
        icon: "warning",
        title: "Too Late to Reschedule",
        text: "Appointment can only be rescheduled once, and only prior to 2 days before the appointment date/time.",
      });
      return;
    }



    // ✅ Proceed normally
    if (appointment.queue_id && !appointment.appointment_id) {
      setSelectedAppointmentForReschedule({
        ...appointment,
        isNewBooking: false,
        patient_id: appointment.patient_id,
        name: appointment.name,
        queue_id: appointment.queue_id,
        isQueueReschedule: true,
      });
      setShowRescheduleModal(true);
      return;
    }

    setSelectedAppointmentForReschedule({
      ...appointment,
      appointment_date_time: `${appointment.date} ${appointment.time_slot?.split(" to ")[0]}`
    });
    setShowRescheduleModal(true);
  };

  const handleRescheduleSuccess = (rescheduledData) => {
    console.log("Reschedule success:", rescheduledData)
    Swal.fire({
      title: "Success!",
      text: "Appointment rescheduled successfully!",
      icon: "success",
      timer: 2000,
      showConfirmButton: false,
    })
    setShowRescheduleModal(false)
    setSelectedAppointmentForReschedule(null)
    setTimeout(() => {
      const today = getTodayDate()
      dispatch(getBookedAppointmentsAction(today, selectedDoctorId || 0))
      dispatch(upcomingAppointmentAction(selectedDate))
    }, 1000)
  }

  const getTomorrowDateString = () => {
    const today = new Date()
    const tomorrow = new Date(today)
    tomorrow.setDate(tomorrow.getDate() + 1)
    return tomorrow.toISOString().split("T")[0]
  }

  const handleOnCancel = (name) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You are about to cancel the appointment for ${name}.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, cancel it!",
      cancelButtonText: "No, keep it",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire("Cancelled!", `The appointment for ${name} has been cancelled.`, "success")
      }
    })
  }

  const handleEmergency = async (patient) => {
    if (!patient) return;

    // Check if patient can perform actions
    if (!canPerformActions(patient)) {
      showScanPatientAlert(patient);
      return;
    }

    // Get the ID to use for loading state (queue_id preferred, fallback to patient_id)
    const loadingId = getLoadingId(patient);
    if (!loadingId) {
      console.error("No valid ID found for patient", patient);
      return;
    }

    // Prevent double clicks
    if (actionLoading.emergencyMarking === loadingId) return;

    const result = await Swal.fire({
      title: "Mark as Emergency",
      text: `Are you sure you want to mark ${patient.name} as emergency?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#dc3545",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, mark as emergency",
      cancelButtonText: "Cancel",
    });

    if (!result.isConfirmed) return;

    // Store the ID
    setActionLoading(prev => ({ ...prev, emergencyMarking: loadingId }));

    try {
      const response = await dispatch(
        markPatientEmergencyAction(patient.queue_id)
      );

      if (response?.status === "success") {
        const today = getTodayDate();

        await dispatch(
          getBookedAppointmentsAction(
            today,
            selectedDoctorId || 0
          )
        );

        Swal.fire({
          icon: "success",
          title: "Marked as Emergency",
          text: `${patient.name} is now marked as emergency.`,
          timer: 2000,
          showConfirmButton: false,
        });
      } else {
        throw new Error("Marking as emergency failed.");
      }

    } catch (error) {
      console.error("Emergency marking failed:", error);

      Swal.fire(
        "Error",
        "Failed to mark as emergency. Please try again.",
        "error"
      );

    } finally {
      setActionLoading(prev => ({ ...prev, emergencyMarking: null }));
    }
  };

  const handleEnqueue = async (appointment) => {
    if (actionLoading.enqueuing === appointment.patient_id) return; // Prevent double clicks

    setActionLoading(prev => ({ ...prev, enqueuing: appointment.patient_id }));

    try {
      const qrcodescanData = JSON.stringify({
        id: String(appointment.patient_id),
        name: formatName(
          [appointment.first_name, appointment.middile_name, appointment.last_name]
            .filter(Boolean)
            .join(" ")
        ),
        mobile: appointment.whatsapp_contact_no || appointment.additional_contact_no || "",
      });

      await dispatch(createReceptionistAction(qrcodescanData, appointment.doctor_id));
      const today = getTodayDate()
      await dispatch(getBookedAppointmentsAction(today, appointment.doctor_id));

      setEnqueuedPatientIds((prev) => [...prev, appointment.patient_id]);

      // Swal.fire("Success", "Patient enqueued successfully!", "success");
    } catch (err) {
      console.error("Error enqueueing:", err);
      Swal.fire("Error", "Failed to enqueue patient", "error");
    } finally {
      setActionLoading(prev => ({ ...prev, enqueuing: null }));
    }
  };



  const handlePauseAll = async () => {
    const doctorId = selectedDoctorValue?.value || selectedDoctorId || 0

    if (!doctorId || doctorId === 0) {
      Swal.fire({
        title: "No Doctor Selected",
        text: "Please select a doctor before trying to pause or resume the queue.",
        icon: "warning",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "OK",
      })
      return
    }

    if (actionLoading.pausing) return

    const actionText = isPaused ? "resume" : "pause"
    const actionTitle = isPaused ? "Resume Doctor Queue" : "Pause Doctor Queue"
    const confirmText = isPaused ? "Yes, resume queue" : "Yes, pause queue"

    Swal.fire({
      title: actionTitle,
      text: `Are you sure you want to ${actionText} this doctor's patient queue?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: isPaused ? "#28a745" : "#f6c23e",
      cancelButtonColor: "#d33",
      confirmButtonText: confirmText,
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const isMulti = "NO" // always "NO"
        setActionLoading(prev => ({ ...prev, pausing: true }));

        try {
          const pauseValue = isPaused ? "No" : "Yes"
          await dispatch(pauseDoctorQueueAction(doctorId, pauseValue))
          const today = getTodayDate()
          await dispatch(getBookedAppointmentsAction(today, doctorId))
        } catch (error) {
          console.error("Queue action failed:", error)
          showErrorAlert(`Failed to ${actionText} queue`)
        } finally {
          setActionLoading(prev => ({ ...prev, pausing: false }));
        }
      }
    })
  }

  // ✅ Clean malformed patient photo URLs
  const getValidPhotoUrl = (photoUrl) => {
    if (
      !photoUrl ||
      photoUrl === "null" ||
      photoUrl === "undefined" ||
      (typeof photoUrl === "string" && photoUrl.trim() === "")
    ) {
      return defaultAvatar;
    }
  
    // Fix malformed URLs (your existing logic)
    if ((photoUrl.match(/https:\/\//g) || []).length > 1) {
      const parts = photoUrl.split("https://");
      return "https://" + parts[parts.length - 1];
    }
  
    return photoUrl;
  };

  const handleOpen = () => {
    window.open("/token-system-multi", "_blank")
  }

  const handleSendLink = async (patientId) => {
    setSendingLinkPatientId(patientId); // show loader
  
    try {
      await dispatch(sendFormLinkAction(patientId));
      setOpenShareMenuId(null);
      const today = getTodayDate();
  
      await dispatch(
        getBookedAppointmentsAction(
          today,
          selectedDoctorId || 0
        )
      );
  
    } catch (error) {
      console.error("Send link error:", error);
  
      setSendingLinkPatientId(null);
  
    } finally {
      // hide loader always
      setSendingLinkPatientId(null);
    }
  };

  const handleRemovePatient = async (patient) => {
    if (!patient) return;

    // Check if patient can perform actions
    if (!canPerformActions(patient)) {
      showScanPatientAlert(patient);
      return;
    }

    // Get the ID to use for loading state (queue_id preferred, fallback to patient_id)
    const loadingId = getLoadingId(patient);
    if (!loadingId) {
      console.error("No valid ID found for patient", patient);
      return;
    }

    // Prevent double clicks
    if (actionLoading.removing === loadingId) return;

    // Store the ID
    setActionLoading(prev => ({ ...prev, removing: loadingId }));

    try {
      await dispatch(removePatientAction(patient));

      const today = getTodayDate();
      await dispatch(getBookedAppointmentsAction(today, selectedDoctorId || 0));

    } catch (e) {
      console.error("Remove patient failed:", e);
      showErrorAlert("Failed to remove patient");
    } finally {
      setActionLoading(prev => ({ ...prev, removing: null }));
    }
  };

  const handleMarkComplete = async (patient) => {
    try {
      const result = await Swal.fire({
        title: "Mark as Complete",
        text: `Are you sure you want to mark ${patient.name} as complete? This will remove them from the queue.`,
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#28a745",
        cancelButtonColor: "#6c757d",
        confirmButtonText: "Yes, mark as complete",
        cancelButtonText: "Cancel",
      })

      if (result.isConfirmed) {
        // Get the ID to use for loading state
        const loadingId = getLoadingId(patient);
        if (!loadingId) return;

        if (actionLoading.completing === loadingId) return;

        setActionLoading(prev => ({ ...prev, completing: loadingId }));

        await dispatch(markPatientCompleteAction(patient.queue_id))
        const today = getTodayDate()
        dispatch(getBookedAppointmentsAction(today, selectedDoctorId || 0))
      }
    } catch (error) {
      console.error("Mark complete failed:", error)
      Swal.fire("Error", "Failed to mark patient as complete", "error")
    } finally {
      setActionLoading(prev => ({ ...prev, completing: null }));
    }
  }



  useEffect(() => {
    dispatch(upcomingAppointmentAction(selectedDate))
  }, [dispatch, selectedDate])

  const handlePatientClick = (patient) => {
    const pid = patient.patient_id || patient.id;

    // ✅ Always navigate directly to patient details page
    // navigate(`/patients/patient-details/${pid}`);
    window.open(`/patients/patient-details/${pid}`, "_blank");
  };

  const dataURLtoFile = (dataUrl, fileName) => {
    let arr = dataUrl.split(',');
    let mime = arr[0].match(/:(.*?);/)[1];
    let bstr = atob(arr[1]);
    let n = bstr.length;
    let u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], fileName, { type: mime });
  };
  const generateFileName = (prefix = "photo") => {
    return `${prefix}_${Date.now()}.png`;
  };


  useEffect(() => {
    const onMessage = (event) => {
      if (event.origin !== window.location.origin) return;
      if (event.data.type !== "PHOTO_CAPTURED") return;

      const source = localStorage.getItem("photoSource");

      const imageDataUrl = event.data.image;

      fetch(imageDataUrl)
        .then(res => res.blob())
        .then(blob => {
          const file = new File([blob], `vitals_${Date.now()}.png`, { type: "image/png" });

          // ⭐ VITALS LOGIC
          if (source === "vitals") {
            setVitalsPatient((prev) => ({
              ...prev,
              uploadedFile: file,
              uploadedFileName: file.name,
            }));

            setUploadedFiles([file]); // vitals table below update
          }

          // ⭐ Queue / Current patient handling is separate
          // if (source === "queue") {
          //   const pid = localStorage.getItem("photoPatientId");
          //   if (pid) {
          //     const previewURL = URL.createObjectURL(file);
          //     setPhotoPreviews((prev) => ({
          //       ...prev,
          //       [pid]: previewURL,
          //     }));
          //   }
          // }
          if (source === "queue") {
            const pid = localStorage.getItem("photoPatientId");

            if (pid) {
              const previewURL = URL.createObjectURL(file);

              setPhotoPreviews((prev) => ({
                ...prev,
                [pid]: previewURL,
              }));

              // 🔥 CALL API HERE
              dispatch(uploadPatientPhotoAction(pid, file));
            }
          }
          localStorage.removeItem("photoSource");
          localStorage.removeItem("photoPatientId");
        });
    };

    window.addEventListener("message", onMessage);
    return () => window.removeEventListener("message", onMessage);
  }, []);



  const secondAndThirdPatients = patients.filter(p => p.status !== "Current").slice(1, 3);



  // In your Receptionist component's handleDownloadReceipt function
  const handleDownloadReceipt = async (url, paymentId) => {
    console.log("Downloading receipt:", { url, paymentId }); // Debug log

    if (!url) {
      Swal.fire("Error", "No receipt link available", "error");
      return;
    }

    if (actionLoading.downloading === paymentId) return;

    setActionLoading(prev => ({ ...prev, downloading: paymentId }));

    try {
      const link = document.createElement("a");
      link.href = url;
      link.download = "receipt.pdf";
      link.target = "_blank";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Failed to download receipt:", error);
      showErrorAlert("Failed to download receipt");
    } finally {
      setTimeout(() => setActionLoading(prev => ({ ...prev, downloading: null })), 1000);
    }
  };

  const openCameraTab = () => {
    const newTab = window.open("", "_blank");
    if (newTab) {
      const mainOrigin = window.location.origin; // used for postMessage security

      newTab.document.write(`
        <html>
          <body style="margin:0;display:flex;flex-direction:column;align-items:center;justify-content:center;height:100vh;background:#000;">
            <video id="video" autoplay playsinline style="width:100%;height:auto;max-height:80vh;border-radius:8px;"></video>
  
            <!-- Round capture button -->
            <button id="snap" 
              style="
                margin-top:20px;
                width:70px;
                height:70px;
                border-radius:50%;
                border:5px solid #fff;
                background-color:rgba(255,255,255,0.1);
                cursor:pointer;
                position:relative;
                transition:all 0.2s ease;
              ">
              <span style="
                position:absolute;
                top:50%;
                left:50%;
                transform:translate(-50%,-50%);
                width:40px;
                height:40px;
                background:white;
                border-radius:50%;
                display:block;
                transition:0.1s;
              "></span>
            </button>
  
            <canvas id="canvas" style="display:none;"></canvas>
  
            <script>
              navigator.mediaDevices.getUserMedia({ video: true }).then(stream => {
                const video = document.getElementById('video');
                video.srcObject = stream;
                const canvas = document.getElementById('canvas');
                const snapBtn = document.getElementById('snap');
  
                snapBtn.onclick = () => {
                  canvas.width = video.videoWidth;
                  canvas.height = video.videoHeight;
                  canvas.getContext('2d').drawImage(video, 0, 0);
                  const dataUrl = canvas.toDataURL('image/png');
                  window.opener.postMessage({ type: 'PHOTO_CAPTURED', image: dataUrl }, '${mainOrigin}');
                  stream.getTracks().forEach(track => track.stop());
                  window.close();
                };
              }).catch(err => {
                alert('Camera access denied: ' + err.message);
                window.close();
              });
            </script>
          </body>
        </html>
      `);
    }
  };


  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "300px" }}>
        <Loader size="lg" />
      </div>
    )
  }

  return (
    <div>
      <style>{`
        #DZ_W_Todo5::-webkit-scrollbar {
          width: 8px;
        }
        
        #DZ_W_Todo5::-webkit-scrollbar-track {
          background: #f1f1f1;
          border-radius: 10px;
        }
        
        #DZ_W_Todo5::-webkit-scrollbar-thumb {
          background: #888;
          border-radius: 10px;
        }
        
        #DZ_W_Todo5::-webkit-scrollbar-thumb:hover {
          background: #555;
        }
        
        .widget-media {
          display: flex;
          flex-direction: column;
        }
        
        .widget-media .timeline {
          margin-bottom: 0;
        }

        /* ✅ Mobile responsive fixes for right card (Patient Queue) ONLY */
        @media (max-width: 768px) {
          .timeline-panel .d-flex.align-items-start {
            flex-direction: column !important;
          }
          .timeline-panel .media.me-2 {
            margin-bottom: 12px;
          }
          .timeline-panel .media-body .d-flex.justify-content-between {
            flex-direction: column !important;
            align-items: flex-start !important;
          }
          .timeline-panel .d-flex.align-items-center.justify-content-end {
            margin-top: 8px;
            justify-content: flex-start !important;
            flex-wrap: wrap;
          }
          .timeline-panel .d-flex.align-items-center.justify-content-end img,
          .timeline-panel .d-flex.align-items-center.justify-content-end .btn {
            width: 28px !important;
            height: 28px !important;
            margin: 2px;
          }
          .timeline-panel .media .rounded-circle img {
            width: 50px !important;
            height: 50px !important;
            object-fit: cover;
          }
          .action-buttons {
            flex-wrap: wrap;
            gap: 8px;
          }
        }
      `}</style>
      <div className="form-head d-flex mb-3 mb-md-4 align-items-start">
        {/* <div className="me-auto d-none d-lg-block">
          <h3 className="text-black font-w600">Welcome to Rohati Ayurved!</h3>
        </div> */}
      </div>

      {/* Controls row */}
      <div className="row g-3 mb-3 align-items-center">
        <div
          className="col-xl-2 col-lg-2 col-sm-6"
          style={{
            position: "relative",
            zIndex: 1,
          }}
        >
          <Select
            value={selectedDoctorOption}
            onChange={(selectedOption) => {
              handleDoctorChange(selectedOption)
              setDoctorError("")
            }}
            options={doctors.map((doctor) => ({
              value: doctor.doctor_id,
              label: doctor.doctor_name,
              specialization: doctor.specialization,
            }))}
            formatOptionLabel={formatOptionLabel}
            styles={{
              ...customStyles,
              control: (base) => ({
                ...base,
                position: "relative",
                zIndex: 1,
              }),
              menu: (base) => ({
                ...base,
                position: "absolute",
                zIndex: 1,
                maxHeight: "200px",
                overflowY: "auto",
              }),
            }}
            menuPosition="absolute"
            menuPlacement="bottom"
            menuShouldScrollIntoView={false}
            closeMenuOnScroll={true}
            placeholder="Select a doctor"
            classNamePrefix="select"
            isClearable={false}
          />
          {doctorError && <div className="text-danger mt-1">{doctorError}</div>}
        </div>

        <div className="col-xl-4 col-lg-4 col-sm-6 position-relative">
          <input
            type="text"
            className="form-control"
            style={{ height: "45px" }}
            placeholder="Search Patient (Name / Mobile / Email)"
            value={searchQuery}
            onChange={(e) => {
              setSearchQuery(e.target.value);
              setShowSuggestions(true);
              setSelectedPatient(null);
            }}
            onKeyDown={handleKeyDown}
          />

          {/* Suggestions Dropdown */}
          {showSuggestions && searchedPatients.length > 0 && (
            <div
              className="border bg-white shadow-sm position-absolute w-100 mt-1 rounded"
              style={{
                zIndex: 999,
                maxHeight: "250px",
                overflowY: "auto"
              }}
            >
              {searchedPatients.map((patient, index) => (
                <div
                  key={patient.patient_id}
                  className="d-flex flex-column px-3 py-2 suggestion-option"
                  style={{
                    cursor: "pointer",
                    backgroundColor: highlightIndex === index ? "#e9f3ff" : "white"
                  }}
                  onMouseEnter={() => setHighlightIndex(index)}
                  onClick={() => handlePatientSelect(patient)}
                >
                  <strong>{patient.patient_name}</strong>
                  <small className="text-muted">
                    {patient.patient_phone} | {patient.patient_email}
                  </small>
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="col-xl-2 col-lg-2 col-sm-4">
          <button
            onClick={checkCameraPermissions}
            className="btn btn-outline-primary btn-rounded d-flex align-items-center justify-content-center w-100"
            style={{ paddingLeft: "15px", paddingRight: "15px", height: "45px" }}
            disabled={actionLoading.scanning}
          >
            {actionLoading.scanning ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Scanning...
              </>
            ) : (
              <>
                <i className="las la-qrcode me-2 scale5" style={{ fontSize: "22px" }}></i>
                <span>Scan Patient</span>
              </>
            )}
          </button>

          {showScanner && (
            <div className="modal d-block" style={{ backgroundColor: "rgba(0, 0, 0, 0.7)", zIndex: 1050 }}>
              <div className="modal-dialog modal-dialog-centered modal-md">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Scan QR Code</h5>
                    <button className="btn-close" onClick={() => setShowScanner(false)}></button>
                  </div>
                  <div className="modal-body text-center">
                    <div id="qr-reader" style={{ width: "100%" }}></div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* New Patient */}
        <div className="col-xl-2 ms-auto col-lg-2 col-sm-4">
          <Link
            to="/patients/add-patient"
            className="btn btn-outline-primary btn-rounded w-100 d-flex align-items-center justify-content-center"
            style={{ height: "45px" }}
          >
            <i className="lar la-calendar-plus me-2 scale5" />
            + New Patient
          </Link>
        </div>

        {/* Public View */}
        <div className="col-xl-2 col-lg-2 col-sm-4">
          <button
            className="btn btn-outline-primary btn-rounded w-100 d-flex align-items-center justify-content-center"
            style={{ height: "45px" }}
            onClick={handleOpen}
          >
            Public View
          </button>
        </div>

      </div>

      {/* Current and Queue */}
      <div className="row mb-3">
        <div className="col-xl-12">
          <div className="card border-0 pb-0">
            <div className="card-body">
              <div className="row align-items-stretch">
                <div
  className="col-xl-6 col-xxl-6 col-lg-6"
  style={{ display: "flex", flexDirection: "column" }}
>
                  <h4 className="card-title mb-3">Current Patient</h4>

                  {!selectedDoctorId ? (
                    <div
                      className="d-flex justify-content-center align-items-center border rounded"
                      style={{ height: "200px", minHeight: "200px" }}
                    >
                      <p className="text-muted text-center m-0">Please select a doctor from dropdown</p>
                    </div>
                  ) : !currentPatient ? (
                    <div
                      className="d-flex justify-content-center align-items-center border rounded "
                      style={{ height: "200px", minHeight: "200px" }}
                    >
                      <p className="text-muted text-center m-0">No current patient.</p>
                    </div>
                  ) : (
                    <div className="p-4 border rounded bg-white w-100 mb-4">
                      {/* ✅ Top action bar */}
                      <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
                        {/* ✅ Left side: Complete button */}
                        <button
                          className="btn btn-sm btn-success"
                          onClick={() => handleMarkComplete(currentPatient)}
                          title="Mark as Complete"
                          style={{ padding: "6px 10px", fontSize: "13px" }}
                          disabled={actionLoading.completing === getLoadingId(currentPatient)}
                        >
                          {actionLoading.completing === getLoadingId(currentPatient) ? (
                            <>
                              <span className="spinner-border spinner-border-sm me-1"></span>
                              Completing...
                            </>
                          ) : (
                            <>
                              <i className="fas fa-check-double me-1"></i>
                              Complete
                            </>
                          )}
                        </button>
                        {/* ✅ Right side controls */}
                        <div
                          className="d-flex align-items-center justify-content-end flex-wrap gap-3"
                          style={{ minHeight: "40px" }}
                        >
                          {/* Emergency badge */}
                          {isEmergencyPatient(currentPatient) && (
                            <span
                              className="d-inline-flex align-items-center"
                              style={{
                                backgroundColor: "#dc3545",
                                color: "white",
                                padding: "4px 8px",
                                borderRadius: "8px",
                                fontSize: "12px",
                                fontWeight: "bold",
                                height: "28px",
                              }}
                            >
                              <i className="fas fa-exclamation-triangle me-1"></i>
                              EMERGENCY
                            </span>
                          )}

                          {/* View / Preview icon */}
                          <Link
                            to="#"
                            title="Preview Patient"
                            className="d-inline-flex align-items-center justify-content-center"
                            style={{ width: "28px", height: "28px" }}
                            onClick={(e) => {
                              e.preventDefault();
                              handlePatientClick(currentPatient);
                            }}
                          >
                            <i className="fa fa-eye text-primary fs-6"></i>
                          </Link>

                          {/* Vitals icon - FIXED with permission check */}
                          {!canPerformActions(currentPatient) ? (
                            <span
                              className="d-inline-flex align-items-center justify-content-center"
                              style={{ width: "28px", height: "28px", opacity: 0.5, cursor: "not-allowed" }}
                             
                              onClick={showScanPatientAlert}
                            >
                              <img
                                src={icon || "/placeholder.svg"}
                                alt="Vitals Disabled"
                                style={{
                                  width: "24px",
                                  height: "24px",
                                  filter: "grayscale(100%)",
                                }}
                              />
                            </span>
                          ) : actionLoading.vitalsOpening &&
                            (actionLoading.vitalsOpening === getLoadingId(currentPatient)) ? (
                            <span className="spinner-border spinner-border-sm text-primary" role="status" aria-hidden="true"></span>
                          ) : (
                            <Link
                              to="#"
                              title="Vitals"
                              className="d-inline-flex align-items-center justify-content-center"
                              style={{ width: "28px", height: "28px" }}
                              onClick={(e) => {
                                e.preventDefault();
                                handleVitalsOpen(currentPatient);
                              }}
                            >
                              <img
                                src={icon || "/placeholder.svg"}
                                alt="Vitals"
                                style={{
                                  width: "24px",
                                  height: "24px",
                                  cursor: "pointer",
                                }}
                              />
                            </Link>
                          )}

                          {/* Back to Queue icon */}
                          {actionLoading.backToQueue === currentPatient.queue_id ? (
                            <span className="spinner-border spinner-border-sm text-primary" role="status" aria-hidden="true"></span>
                          ) : (
                            <Link
                              to="#"
                              title="Add Back to Queue"
                              className="d-inline-flex align-items-center justify-content-center"
                              style={{ width: "28px", height: "28px" }}
                              onClick={(e) => {
                                e.preventDefault();
                                handleBackToQueue(currentPatient);
                              }}
                            >
                              <img
                                src={backtoqueue}
                                alt="Add Back to Queue"
                                style={{
                                  width: "24px",
                                  height: "24px",
                                  cursor: "pointer",
                                }}
                              />
                            </Link>
                          )}
                        </div>
                      </div>

                      {/* ✅ Patient Info */}
                      <div className="text-center mb-4">
                        <div style={{ position: "relative", display: "inline-block" }}>
                          {actionLoading.uploadingPhoto === currentPatient.patient_id ? (
                            <div className="d-flex justify-content-center align-items-center" style={{ width: "120px", height: "120px" }}>
                              <span className="spinner-border text-primary" role="status" aria-hidden="true"></span>
                            </div>
                          ) : (
                            <img
                              alt="avatar"
                              width="120"
                              height="120"
                              src={photoPreviews[currentPatient.patient_id] || getValidPhotoUrl(currentPatient?.patient_photo)}
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = defaultAvatar;
                              }}
                              className="rounded-circle border"
                              style={{
                                objectFit: "cover",
                                cursor: "pointer",
                                backgroundColor: "transparent",
                                border: isEmergencyPatient(currentPatient)
                                  ? "4px solid #dc3545"
                                  : "4px solid #e5e7eb",
                                transition: "0.3s",
                              }}
                              onClick={() => setPhotoModalPatient(currentPatient)}
                            />
                          )}

                          <input
                            type="file"
                            id={`choose-photo-${currentPatient?.patient_id}`}
                            accept="image/jpeg,image/png"
                            style={{ display: "none" }}
                            onChange={async (e) => {
                              const file = e.target.files[0];
                              if (!file || !currentPatient?.patient_id) return;

                              const previewUrl = URL.createObjectURL(file);
                              setPhotoPreviews((prev) => ({
                                ...prev,
                                [currentPatient.patient_id]: previewUrl,
                              }));

                              try {
                                await handleUploadPatientPhoto(currentPatient, file);
                              } catch (err) {
                                console.error("Upload error:", err);
                                setPhotoPreviews((prev) => {
                                  const updated = { ...prev };
                                  delete updated[currentPatient.patient_id];
                                  return updated;
                                });
                              }
                            }}
                          />

                          <input
                            type="file"
                            id={`take-photo-${currentPatient?.patient_id}`}
                            accept="image/jpeg,image/png"
                            capture="environment"
                            style={{ display: "none" }}
                            onChange={async (e) => {
                              const file = e.target.files[0];
                              if (!file || !currentPatient?.patient_id) return;

                              const previewUrl = URL.createObjectURL(file);
                              setPhotoPreviews((prev) => ({
                                ...prev,
                                [currentPatient.patient_id]: previewUrl,
                              }));

                              try {
                                await handleUploadPatientPhoto(currentPatient, file);
                              } catch (err) {
                                console.error("Upload error:", err);
                                setPhotoPreviews((prev) => {
                                  const updated = { ...prev };
                                  delete updated[currentPatient.patient_id];
                                  return updated;
                                });
                              }
                            }}
                          />
                        </div>

                        <h5
                          className="mt-3 mb-0 fw-bold text-dark d-flex justify-content-center align-items-center"
                          style={{
                            gap: "8px",
                            whiteSpace: "nowrap"
                          }}
                        >
                          <span>{currentPatient?.name || ""}</span>

                          {currentPatient?.partner_name && (
                            <span className="d-flex align-items-center" style={{ gap: "4px" }}>
                              <img
                                src={connect}
                                alt="Partner"
                                width="18"
                                height="18"
                                style={{ cursor: "pointer" }}
                                title={`Call ${currentPatient.partner_name}`}
                                onClick={() => {
                                  if (currentPatient?.partner_phone) {
                                    window.location.href = `tel:${currentPatient.partner_phone}`;
                                  }
                                }}
                              />
                              <span>{currentPatient.partner_name}</span>
                            </span>
                          )}

                          <span className="badge bg-primary">
                            {currentPatient?.status}
                          </span>
                        </h5>

                        <Modal
                          show={!!photoModalPatient}
                          onHide={() => setPhotoModalPatient(null)}
                          centered
                        >
                          <Modal.Header closeButton>
                            <Modal.Title>Upload Patient Photo</Modal.Title>
                          </Modal.Header>
                          <Modal.Body className="text-center">
                            <Button
                              variant="primary"
                              className="w-100 mb-3"
                              onClick={() => {
                                document.getElementById(`choose-photo-${photoModalPatient?.patient_id}`).click();
                                setPhotoModalPatient(null);
                              }}
                            >
                              <i className="fas fa-image me-2"></i> Choose Photo
                            </Button>
                            <Button
                              variant="success"
                              className="w-100"
                              onClick={() => {
                                localStorage.setItem("photoSource", "current");
                                localStorage.setItem("photoPatientId", currentPatient.patient_id);
                                setPhotoModalPatient(null);
                                openCameraTab();
                              }}
                            >
                              <i className="fas fa-camera me-2"></i> Take Photo
                            </Button>
                          </Modal.Body>
                        </Modal>
                      </div>

                      {/* ✅ Patient Details Grid */}
                      <div className="row px-2 py-3 bg-gray-50 rounded">
                        {[
                          { label: "Gender", value: currentPatient.gender || "-" },
                          { label: "Age", value: currentPatient.age ? `${currentPatient.age} years` : "-" },
                          { label: "Weight", value: currentPatient.weight ? `${currentPatient.weight} kg` : "-" },
                          { label: "Occupation", value: currentPatient.occupation || "-" },
                          { label: "City", value: currentPatient.city || "-" },
                          { label: "Contact", value: currentPatient.whatsapp_contact_no || "-" },
                          { label: "Marital", value: currentPatient.marital_status || "-" },
                          { label: "Disease", value: currentPatient.diseases || currentPatient.opd_diseases || "-" },
                        ].map((item, index, arr) => {
                          const lastRowStart = arr.length - (arr.length % 3 || 3);
                          return (
                            <div
                              key={index}
                              className="col-md-4 col-sm-6 py-2 text-wrap"
                              style={{
                                wordBreak: "break-word",
                                whiteSpace: "normal",
                                marginBottom: "4px",
                                borderBottom: index >= lastRowStart ? "none" : "1px solid #ddd",
                              }}
                            >
                              <strong className="text-gray-700">{item.label}: </strong>
                              <span className="ml-2 text-gray-900">{item.value}</span>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}

                  {/* Next Patient Section */}
                  <div className="border-0 pb-0" style={{ marginTop: "10px" }}>
                    <div className="pb-0 d-flex flex-wrap justify-content-between align-items-center gap-2">
                      <h4 className="card-title mb-0" style={{ fontWeight: 600 }}>
                        Next Patient
                      </h4>
                    </div>

                    <div className="pt-3">
                      {!selectedDoctorId ? (
                        <div className="d-flex justify-content-center align-items-center border rounded" style={{ height: "150px" }}>
                          <p className="text-muted text-center m-0">Please select a doctor from dropdown</p>
                        </div>
                      ) : nextPatient ? (
                        <ul className="timeline">
                          {(() => {
                            const patient = nextPatient;

                            return (
                              <li key={patient.queue_id}>
                                <div
                                  className="timeline-panel"
                                  style={{
                                    backgroundColor: isEmergencyPatient(patient)
                                      ? "rgba(220, 53, 69, 0.1)"
                                      : patient.questionnaire_filled === "No"
                                        ? "rgba(135, 206, 250, 0.3)"
                                        : "transparent",
                                    border: isEmergencyPatient(patient)
                                      ? "2px solid rgba(220, 53, 69, 0.3)"
                                      : patient.questionnaire_filled === "No"
                                        ? "2px solid rgba(135, 206, 250, 0.6)"
                                        : "1px solid #e9ecef",
                                    borderRadius: "8px",
                                    padding: "15px",
                                    marginBottom: "10px",
                                    transition: "all 0.3s ease",
                                    position: "relative",
                                  }}
                                >
                                  <div className="d-flex align-items-start w-100">
                                    <div className="media me-2">
                                      <div style={{ position: "relative", display: "inline-block" }}>
                                        {actionLoading.uploadingPhoto === patient.patient_id ? (
                                          <div className="d-flex justify-content-center align-items-center" style={{ width: "50px", height: "50px" }}>
                                            <span className="spinner-border spinner-border-sm text-primary" role="status" aria-hidden="true"></span>
                                          </div>
                                        ) : (
                                          <div
                                            style={{
                                              width: "50px",
                                              height: "50px",
                                              borderRadius: "50%",

                                            }}
                                          >
                                            <img
                                              alt="avatar"
                                              src={
                                                photoPreviews[patient.patient_id] ||
                                                getValidPhotoUrl(patient?.patient_photo)
                                              }
                                              onError={(e) => {
                                                e.target.onerror = null;
                                                e.target.src = defaultAvatar;
                                              }}
                                              style={{
                                                width: "100%",
                                                height: "100%",
                                                objectFit: "cover",
                                                display: "block",
                                                cursor: "pointer",
                                              }}
                                              onClick={() => setPhotoModalPatient(patient)}
                                            />
                                          </div>
                                        )}

                                        <input
                                          type="file"
                                          id={`choose-photo-${patient.patient_id}`}
                                          accept="image/jpeg,image/png"
                                          style={{ display: "none" }}
                                          onChange={async (e) => {
                                            const file = e.target.files[0];
                                            if (!file || !patient?.patient_id) return;

                                            const previewUrl = URL.createObjectURL(file);
                                            setPhotoPreviews((prev) => ({
                                              ...prev,
                                              [patient.patient_id]: previewUrl,
                                            }));

                                            try {
                                              await handleUploadPatientPhoto(patient, file);
                                            } catch (err) {
                                              console.error("Upload error:", err);
                                              setPhotoPreviews((prev) => {
                                                const updated = { ...prev };
                                                delete updated[patient.patient_id];
                                                return updated;
                                              });
                                            }
                                          }}
                                        />
                                      </div>

                                      <div
                                        className="rounded-circle d-none"
                                        style={{
                                          width: "50px",
                                          height: "50px",
                                          backgroundColor: "#e9ecef",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          fontSize: "20px",
                                          color: "#6c757d",
                                        }}
                                      >
                                        <i className="fas fa-user"></i>
                                      </div>
                                    </div>
                                    <div className="media-body w-100">
                                      <div className="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center flex-wrap mb-2">
                                        <h5
                                          className="mb-1 d-flex align-items-center"
                                          style={{
                                            gap: "8px",
                                            whiteSpace: "nowrap",
                                            overflow: "hidden"
                                          }}
                                        >
                                          <span>{formatName(patient.name)}</span>

                                          {/* Partner */}
                                          {patient.partner_name && (
                                            <span className="d-flex align-items-center" style={{ gap: "4px" }}>
                                              <img
                                                src={connect}
                                                alt="Partner"
                                                width="18"
                                                height="18"
                                                style={{ cursor: "pointer" }}
                                                title={`Call ${patient.partner_name}`}
                                                onClick={() => {
                                                  if (patient.partner_phone) {
                                                    window.location.href = `tel:${patient.partner_phone}`;
                                                  }
                                                }}
                                              />
                                              <span style={{ fontSize: "14px", color: "#6c757d" }}>
                                                {patient.partner_name}
                                              </span>
                                            </span>
                                          )}

                                          {/* Status */}
                                          <span className="badge bg-primary">{patient.status}</span>

                                          {/* Loader / Share */}

                                        </h5>


                                        <div
                                          className="d-flex align-items-center justify-content-end mb-2"
                                          style={{ gap: "10px" }}
                                        >
                                          {isEmergencyPatient(patient) && (
                                            <div
                                              style={{
                                                backgroundColor: "#dc3545",
                                                color: "white",
                                                padding: "4px 10px",
                                                borderRadius: "12px",
                                                fontSize: "11px",
                                                fontWeight: "600",
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "4px",
                                                whiteSpace: "nowrap",
                                                boxShadow: "0 4px 6px rgba(0,0,0,0.15)",
                                                lineHeight: 1,
                                              }}
                                            >
                                              <i className="fas fa-exclamation-triangle"></i>
                                              EMERGENCY
                                            </div>
                                          )}
                                          <Link
                                            to="#"
                                            title="Preview Patient"
                                            onClick={(e) => {
                                              e.preventDefault();
                                              handlePatientClick(patient);
                                            }}
                                          >
                                            <i className="fa fa-eye text-primary fs-6"></i>
                                          </Link>

                                          {/* Vitals icon in Next Patient - FIXED with permission check */}
                                          {!canPerformActions(patient) ? (
                                            <span
                                              className="d-inline-flex align-items-center justify-content-center"
                                              style={{ width: "28px", height: "28px", opacity: 0.5, cursor: "not-allowed" }}
                                             
                                              onClick={showScanPatientAlert}
                                            >
                                              <img
                                                src={icon || "/placeholder.svg"}
                                                alt="Vitals Disabled"
                                                style={{
                                                  width: "24px",
                                                  height: "24px",
                                                  filter: "grayscale(100%)",
                                                }}
                                              />
                                            </span>
                                          ) : actionLoading.vitalsOpening &&
                                            (actionLoading.vitalsOpening === getLoadingId(patient)) ? (
                                            <span className="spinner-border spinner-border-sm text-primary" role="status" aria-hidden="true"></span>
                                          ) : (
                                            <Link
                                              to="#"
                                              onClick={(e) => {
                                                e.preventDefault()
                                                handleVitalsOpen(patient)
                                              }}
                                              style={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                              }}
                                            >
                                              <img
                                                src={icon || "/placeholder.svg"}
                                                alt="Vitals"
                                                style={{
                                                  cursor: "pointer",
                                                  width: "28px",
                                                  height: "28px",
                                                }}
                                                title="Vitals"
                                              />
                                            </Link>
                                          )}

                                          <img
                                            src={call}
                                            alt="Call"
                                            width="28"
                                            height="28"
                                            className="cursor-pointer"
                                            title={`Call ${patient.name}`}
                                            onClick={() => (window.location.href = `tel:${patient.whatsapp_contact_no}`)}
                                          />

                                          {isQuestionnaireFilled(patient) ? (
                                            (() => {
                                              const isPaymentPending = patient.is_payment === "No";
                                              if (isPaymentPending) {
                                                return (
                                                  <img
                                                    src={Markcurrent}
                                                    alt="Mark Current Disabled - Payment Pending"
                                                    width="28"
                                                    height="28"
                                                    className="cursor-pointer"
                                                    title="Payment pending - Please collect payment first"
                                                    style={{ opacity: 0.5, cursor: "not-allowed" }}
                                                    onClick={() =>
                                                      Swal.fire({
                                                        icon: "warning",
                                                        title: "Payment Pending",
                                                        html: `This patient has <b>payment pending</b>.<br/>Please collect payment before marking as current.`,
                                                        confirmButtonText: "OK",
                                                        confirmButtonColor: "#fd7e14",
                                                      })
                                                    }
                                                  />
                                                );
                                              }
                                              
                                              return actionLoading.markingCurrent === getLoadingId(patient) ? (
                                                <span className="spinner-border spinner-border-sm text-primary" role="status" aria-hidden="true"></span>
                                              ) : (
                                                <img
                                                  src={Markcurrent}
                                                  alt="Mark Current"
                                                  width="28"
                                                  height="28"
                                                  className="cursor-pointer"
                                                  title="Mark as Current"
                                                  onClick={() => handleMarkCurrent(patient)}
                                                  style={{
                                                    opacity: isPaused || actionLoading.markingCurrent === getLoadingId(patient) ? 0.5 : 1,
                                                  }}
                                                />
                                              );
                                            })()
                                          ) : (
                                            <img
                                              src={Markcurrent}
                                              alt="Mark Current Disabled"
                                              width="28"
                                              height="28"
                                              className="cursor-pointer"
                                              title="Please send questionnaire link first"
                                              style={{ opacity: 0.5, cursor: "not-allowed" }}
                                              onClick={() =>
                                                Swal.fire({
                                                  icon: "info",
                                                  title: "Action Required",
                                                  html: `Please <b>click the Link icon</b> to send the questionnaire.<br/>Once done, Mark Current will be enabled.`,
                                                  confirmButtonText: "OK",
                                                })
                                              }
                                            />
                                          )}
                                          {actionLoading.backToQueue === patient.queue_id ? (
          <span
            className="spinner-border spinner-border-sm text-primary"
            role="status"
            aria-hidden="true"
          ></span>
        ) : (
          <Link
            to="#"
            title="Add Back to Queue"
            className="d-inline-flex align-items-center justify-content-center"
            style={{ width: "28px", height: "28px" }}
            onClick={(e) => {
              e.preventDefault();
              handleBackToQueue(patient);
            }}
          >
            <img
              src={backtoqueue}
              alt="Add Back to Queue"
              style={{
                width: "24px",
                height: "24px",
                cursor: "pointer",
              }}
            />
          </Link>
        )}
                                        </div>
                                      </div>

                                      <p
                                        className="mb-1 small"
                                        style={{
                                          color: "#6c757d",
                                          fontSize: "14px",
                                          fontWeight: 500
                                        }}
                                      >
                                        {[
                                          patient.marital_status,
                                          patient.diseases == "" || patient.diseases == null ? patient.opd_diseases : patient.diseases,
                                          patient.mode && patient.mode.trim() !== "" ? patient.mode : "Offline",
                                          patient.timeSlot,
                                          `Dr. ${patient.doctor}`
                                        ].filter(Boolean).join(" | ")}
                                      </p>

                                      <p
                                        className="mb-1 small"
                                        style={{
                                          color: "#6c757d",
                                          fontSize: "14px",
                                          fontWeight: 500
                                        }}
                                      >
                                        {patient.whatsapp_contact_no && (
                                          <> {patient.whatsapp_contact_no}</>
                                        )}
                                        {patient.whatsapp_contact_no && patient.location && " | "}
                                        {patient.location && (
                                          <> {patient.location}</>
                                        )}
                                      </p>

                                      <div
                                        className="d-flex flex-wrap align-items-center gap-2"
                                        style={{ rowGap: "6px" }}
                                      >
                                        {/* {patient.showCollectButton && (
                                          <img
                                            src={collectpayment}
                                            alt="Collect Payment"
                                            width={32}
                                            height={32}
                                            className="cursor-pointer"
                                            title="Collect Payment"
                                            onClick={() => handleCollectPayment(patient)}
                                            style={{
                                              padding: "4px",
                                              objectFit: "contain",
                                            }}
                                          />
                                        )} */}
                                        {patient.showCollectButton && (
  <img
    src={collectpayment}
    alt="Collect Payment"
    width={32}
    height={32}
    title={
      patient?.is_presented === "No"
        ? "Scan patient first"
        : "Collect Payment"
    }
    onClick={() => {
      if (patient?.is_presented === "No") return; // ❌ block click
      handleCollectPayment(patient); // ✅ allow
    }}
    style={{
      padding: "4px",
      objectFit: "contain",
      cursor:
        patient?.is_presented === "No" ? "not-allowed" : "pointer",
      opacity: patient?.is_presented === "No" ? 0.4 : 1, // 🔥 disabled look
    }}
  />
)}

                                        {/* Remove/Cancel icon in Next Patient - FIXED with permission check */}
                                        {!canPerformActions(patient) ? (
                                          <span
                                            className="d-inline-flex align-items-center justify-content-center"
                                            style={{ width: "32px", height: "32px", opacity: 0.5, cursor: "not-allowed" }}
                                         
                                            onClick={showScanPatientAlert}
                                          >
                                            <img
                                              src={cancel}
                                              alt="Cancel Disabled"
                                              style={{
                                                width: "28px",
                                                height: "28px",
                                                filter: "grayscale(100%)",
                                              }}
                                            />
                                          </span>
                                        ) : actionLoading.removing &&
                                          (actionLoading.removing === getLoadingId(patient)) ? (
                                          <span className="spinner-border spinner-border-sm text-danger" role="status" aria-hidden="true"></span>
                                        ) : (
                                          <img
                                            src={cancel}
                                            alt="Cancel Appointment"
                                            width={32}
                                            height={32}
                                            className="cursor-pointer"
                                            title="Cancel Appointment"
                                            onClick={() => handleRemovePatient(patient)}
                                            style={{
                                              padding: "4px",
                                              objectFit: "contain",
                                            }}
                                          />
                                        )}

                                        {/* Emergency icon in Next Patient - FIXED with permission check */}
                                        {!canPerformActions(patient) ? (
                                          <span
                                            className="d-inline-flex align-items-center justify-content-center"
                                            style={{ width: "28px", height: "28px", opacity: 0.5, cursor: "not-allowed" }}
                                           
                                            onClick={showScanPatientAlert}
                                          >
                                            <img
                                              src={emergencyIcon}
                                              alt="Emergency Disabled"
                                              style={{
                                                width: "24px",
                                                height: "24px",
                                                filter: "grayscale(100%)",
                                              }}
                                            />
                                          </span>
                                        ) : actionLoading.emergencyMarking &&
                                          (actionLoading.emergencyMarking === getLoadingId(patient)) ? (
                                          <span className="spinner-border spinner-border-sm text-danger" role="status" aria-hidden="true"></span>
                                        ) : (
                                          <img
                                            src={emergencyIcon}
                                            alt="Emergency"
                                            width="28"
                                            height="28"
                                            className="cursor-pointer"
                                            title={isEmergencyPatient(patient) ? "Emergency Set" : "Mark as Emergency"}
                                            style={{
                                              opacity: (actionLoading.emergencyMarking &&
                                                (actionLoading.emergencyMarking === getLoadingId(patient))) ? 0.5 : 1
                                            }}
                                            onClick={() => handleEmergency(patient)}
                                          />
                                        )}

                                        {isLastPatientInQueue(patient) && (
                                          <button
                                            className="btn btn-sm btn-success"
                                            onClick={() => handleMarkComplete(patient)}
                                            title="Mark as Complete"
                                            disabled={actionLoading.completing === getLoadingId(patient)}
                                          >
                                            {actionLoading.completing === getLoadingId(patient) ? (
                                              <>
                                                <span className="spinner-border spinner-border-sm me-1"></span>
                                                Completing...
                                              </>
                                            ) : (
                                              <i className="fas fa-check-double me-1"></i>
                                            )}
                                          </button>
                                        )}

                                        {actionLoading.sendingReminder === patient.id ? (
                                          <span className="spinner-border spinner-border-sm text-primary" role="status" aria-hidden="true"></span>
                                        ) : (
                                          <img
                                            src={remainder}
                                            alt="Send Reminder"
                                            width={32}
                                            height={32}
                                            className="cursor-pointer"
                                            title="Send Reminder"
                                            onClick={() => handleSendReminder(patient.id)}
                                            style={{
                                              padding: "4px",
                                              objectFit: "contain",
                                            }}
                                          />
                                        )}

                                        {patient.showReceiptIcon && (
                                          <div className="d-flex align-items-center">
                                            {actionLoading.downloading === patient.payment_id ? (
                                              <div
                                                className="spinner-border text-primary"
                                                role="status"
                                                style={{ width: "24px", height: "24px" }}
                                              >
                                                <span className="visually-hidden">Loading...</span>
                                              </div>
                                            ) : (
                                              <img
                                                src={pdfIcon || "/placeholder.svg"}
                                                alt="Download PDF"
                                                width={28}
                                                height={28}
                                                style={{ cursor: "pointer" }}
                                                title="Download Receipt"
                                                onClick={() =>
                                                  handleDownloadReceipt(
                                                    patient.receipt_download_link,
                                                    patient.payment_id
                                                  )
                                                }
                                              />
                                            )}
                                          </div>
                                        )}

                                        {/* Reschedule Icon */}
                                        <img
                                          src={Reshedule || "/placeholder.svg"}
                                          alt="Reschedule"
                                          width={28}
                                          height={28}
                                          style={{ cursor: "pointer" }}
                                          title="Reschedule Appointment"
                                          onClick={() => handleReschedule(patient)}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </li>
                            );
                          })()}
                        </ul>
                      ) : (
                        <div className="d-flex justify-content-center align-items-center border rounded" style={{ height: "150px", minHeight: "150px" }}>
                          <p className="text-muted text-center m-0">No next patient.</p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div className="col-xl-6 col-xxl-6 col-lg-6" style={{ display: "flex", flexDirection: "column", height: "auto" }}>
                  <div className="border-0 pb-0" style={{ display: "flex", flexDirection: "column", overflow: "visible" }}>
                    <div className="pb-0 d-flex flex-wrap justify-content-between align-items-center gap-2" style={{ marginTop: "-5px", flexShrink: 0 }}>
                      <h4 className="card-title mb-0" style={{ fontWeight: 600 }}>
                        Patient Queue
                      </h4>
                      {(waitingPatients?.length || 0) > 0 && (
                        <button
                          className={`btn btn-sm ${isPaused ? "btn-success" : "btn-warning"}`}
                          onClick={handlePauseAll}
                          disabled={actionLoading.pausing}
                        >
                          {actionLoading.pausing && <span className="spinner-border spinner-border-sm me-2"></span>}
                          {isPaused ? "Resume" : "Pause Queue"}
                        </button>
                      )}
                    </div>
                    <div
  className="pt-3"
  style={{
    display: "flex",
    flexDirection: "column"
  }}
>
                      <div
                        id="DZ_W_Todo5"
                        className="widget-media dz-scroll"
                        style={{
                          overflowY: "auto",
                          marginTop: "-12px",
                          paddingRight: "10px",
                          scrollBehavior: "smooth",
                          maxHeight: "600px"
                        }}
                      >
                        {!selectedDoctorId ? (
                          <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "100px", padding: "20px" }}>
                            <p className="text-muted text-center m-0">Please select a doctor from dropdown</p>
                          </div>
                        ) : rightPanelLoading ? (
                          <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "100px", padding: "20px" }}>
                            <Loader size="lg" />
                          </div>
                        ) : waitingPatients.length === 0 ? (
                          <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "100px", padding: "20px" }}>
                            <p className="text-muted text-center m-0">No patients in queue.</p>
                          </div>
                        ) : (
                          <ul className="timeline">
                            {waitingPatients.map((patient, index) => (
                              <li key={patient.id || patient.queue_id}>
                                <div
                                  className="timeline-panel"
                                  style={{
                                    backgroundColor: isEmergencyPatient(patient)
                                      ? "rgba(220, 53, 69, 0.1)"
                                      : patient.is_presented === "No"
                                        ? "#e9ecef"
                                        : patient.questionnaire_filled === "No"
                                          ? "rgba(255, 159, 64, 0.15)"

                                          : "transparent",
                                    border: isEmergencyPatient(patient)
                                      ? "2px solid rgba(220, 53, 69, 0.3)"
                                      : patient.is_presented === "No"
                                        ? "2px solid #ced4da"
                                        : patient.questionnaire_filled === "No"
                                          ? "2px solid rgba(255, 159, 64, 0.5)"

                                          : "1px solid #e9ecef",
                                    borderRadius: "8px",
                                    padding: "15px",
                                    marginBottom: "10px",
                                    transition: "all 0.3s ease",
                                    position: "relative",
                                  }}
                                >
                                  <div className="d-flex align-items-start w-100">
                                    <div className="media me-2">
                                      <div style={{ position: "relative", display: "inline-block" }}>
                                        {actionLoading.uploadingPhoto === patient.patient_id ? (
                                          <div className="d-flex justify-content-center align-items-center" style={{ width: "50px", height: "50px" }}>
                                            <span className="spinner-border spinner-border-sm text-primary" role="status" aria-hidden="true"></span>
                                          </div>
                                        ) : (
                                          <div
                                            style={{
                                              width: "50px",
                                              height: "50px",
                                              borderRadius: "50%",
                                              // ✅ THIS is the key

                                            }}
                                          >
                                            <img
                                              alt="avatar"
                                              src={
                                                photoPreviews[patient.patient_id] ||
                                                getValidPhotoUrl(patient?.patient_photo)
                                              }
                                              onError={(e) => {
                                                e.target.onerror = null;
                                                e.target.src = defaultAvatar;
                                              }}
                                              style={{
                                                width: "100%",
                                                height: "100%",
                                                objectFit: "cover", // ✅ ensures full fill
                                                display: "block",
                                                cursor: "pointer",
                                              }}
                                              onClick={() => setPhotoModalPatient(patient)}
                                            />
                                          </div>
                                        )}

                                        <input
                                          type="file"
                                          id={`choose-photo-${patient?.patient_id}`}
                                          accept="image/jpeg,image/png"
                                          style={{ display: "none" }}
                                          onChange={async (e) => {
                                            const file = e.target.files[0];
                                            const patientId = patient?.patient_id;

                                            if (!file) {
                                              Swal.fire("Error", "No file selected", "error");
                                              return;
                                            }

                                            if (!patientId) {
                                              Swal.fire("Error", "Patient ID not found. Please refresh and try again.", "error");
                                              return;
                                            }

                                            const previewUrl = URL.createObjectURL(file);
                                            setPhotoPreviews((prev) => ({
                                              ...prev,
                                              [patientId]: previewUrl,
                                            }));

                                            try {
                                              await handleUploadPatientPhoto(patient, file);
                                            } catch (err) {
                                              console.error("Upload error:", err);
                                              Swal.fire("Error", "Upload failed", "error");
                                              setPhotoPreviews((prev) => {
                                                const updated = { ...prev };
                                                delete updated[patientId];
                                                return updated;
                                              });
                                            }
                                          }}
                                        />

                                        <input
                                          type="file"
                                          id={`take-photo-${patient.patient_id}`}
                                          accept="image/jpeg,image/png"
                                          capture="environment"
                                          style={{ display: "none" }}
                                          onChange={async (e) => {
                                            const file = e.target.files[0];
                                            if (!file || !patient?.patient_id) return;

                                            const previewUrl = URL.createObjectURL(file);
                                            setPhotoPreviews((prev) => ({
                                              ...prev,
                                              [patient.patient_id]: previewUrl,
                                            }));

                                            try {
                                              await handleUploadPatientPhoto(patient, file);
                                            } catch (err) {
                                              console.error("Upload error:", err);
                                              Swal.fire("Error", "Upload failed", "error");
                                              setPhotoPreviews((prev) => {
                                                const updated = { ...prev };
                                                delete updated[patient.patient_id];
                                                return updated;
                                              });
                                            }
                                          }}
                                        />
                                      </div>

                                      <div
                                        className="rounded-circle d-none"
                                        style={{
                                          width: "50px",
                                          height: "50px",
                                          backgroundColor: "#e9ecef",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          fontSize: "20px",
                                          color: "#6c757d",
                                        }}
                                      >
                                        <i className="fas fa-user"></i>
                                      </div>
                                    </div>

                                    <div className="media-body w-100">
                                      <div className="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center flex-wrap mb-2">
                                        <h5
                                          className="mb-1"
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "8px",
                                            flexWrap: "wrap"
                                          }}
                                        >
                                          {formatName(patient?.name)}
                             

                                          {patient?.partner_name && (
                                            <span
                                              className="d-flex align-items-center"
                                              style={{ gap: "6px" }}
                                            >
                                              <img
                                                src={connect}
                                                alt="Partner"
                                                width="18"
                                                height="18"
                                                style={{ cursor: "pointer" }}
                                                // title={`Call`}
                                                onClick={() => {
                                                  if (patient?.partner_phone) {
                                                    window.location.href = `tel:${patient.partner_phone}`;
                                                  }
                                                }}
                                              />
                                              <span>{patient.partner_name}</span>
                                              
                                         
                                            </span>
                                          )}
                                      
                                          <span className="badge bg-primary ms-1">
                                            {patient?.status}
                                          </span>
                               

                                        </h5>

                                        <div
                                          className="d-flex align-items-center justify-content-end mb-2"
                                          style={{ gap: "10px" }}
                                        >
                                          {(() => {
                                            const status = getPatientStatus(patient);
                                            if (!status) return null;

                                            return (
                                              <div
                                                style={{
                                                  backgroundColor: status.priority === 1 ? "rgba(220, 53, 69, 0.1)" : "rgba(100, 100, 100, 0.05)",
                                                  color: status.color,
                                                  padding: "6px 10px",
                                                  borderRadius: "6px",
                                                  fontSize: "12px",
                                                  fontWeight: "600",
                                                  display: "flex",
                                                  flexDirection: "column",
                                                  gap: "2px",
                                                  whiteSpace: "nowrap",
                                                  lineHeight: 1.2,
                                                  border: `1px solid ${status.color}33`
                                                }}
                                              >
                                                <span style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                                                  <i className={status.icon}></i>
                                                  <strong>{status.label}</strong>
                                                </span>
                                                {status.message && (
                                                  <span style={{ fontSize: "10px", fontWeight: "400", opacity: 0.9 }}>
                                                    {status.message}
                                                  </span>
                                                )}
                                              </div>
                                            );
                                          })()}

                                          <Link
                                            to="#"
                                            title="Preview Patient"
                                            onClick={(e) => {
                                              e.preventDefault();
                                              handlePatientClick(patient);
                                            }}
                                          >
                                            <i className="fa fa-eye text-primary fs-6"></i>
                                          </Link>

                                          {/* Vitals icon in Patient Queue - FIXED with permission check */}
                                          {!canPerformActions(patient) ? (
                                            <span
                                              className="d-inline-flex align-items-center justify-content-center"
                                              style={{ width: "28px", height: "28px", opacity: 0.5, cursor: "not-allowed" }}
                                              
                                              onClick={showScanPatientAlert}
                                            >
                                              <img
                                                src={icon || "/placeholder.svg"}
                                                alt="Vitals Disabled"
                                                style={{
                                                  width: "24px",
                                                  height: "24px",
                                                  filter: "grayscale(100%)",
                                                }}
                                              />
                                            </span>
                                          ) : actionLoading.vitalsOpening &&
                                            (actionLoading.vitalsOpening === getLoadingId(patient)) ? (
                                            <span
                                              className="spinner-border spinner-border-sm text-primary"
                                              role="status"
                                              aria-hidden="true"
                                            ></span>
                                          ) : (
                                            <Link
                                              to="#"
                                              onClick={(e) => {
                                                e.preventDefault();
                                                handleVitalsOpen(patient);
                                              }}
                                              style={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                              }}
                                            >
                                              <img
                                                src={icon || "/placeholder.svg"}
                                                alt="Vitals"
                                                style={{
                                                  cursor: "pointer",
                                                  width: "28px",
                                                  height: "28px",
                                                }}
                                                title="Vitals"
                                              />
                                            </Link>
                                          )}
                                          <img
                                            src={call}
                                            alt="Call"
                                            width="28"
                                            height="28"
                                            className="cursor-pointer"
                                            title={`Call ${patient.name}`}
                                            onClick={() => (window.location.href = `tel:${patient.whatsapp_contact_no}`)}
                                          />

                                          {isQuestionnaireFilled(patient) ? (
                                            (() => {
                                              const isPaymentPending = patient.is_payment === "No";
                                              if (isPaymentPending) {
                                                return (
                                                  <img
                                                    src={Markasnext}
                                                    alt="Mark Next Disabled - Payment Pending"
                                                    width="28"
                                                    height="28"
                                                    className="cursor-pointer"
                                                    title="Payment pending - Please collect payment first"
                                                    style={{ opacity: 0.5, cursor: "not-allowed" }}
                                                    onClick={() =>
                                                      Swal.fire({
                                                        icon: "warning",
                                                        title: "Payment Pending",
                                                        html: `This patient has <b>payment pending</b>.<br/>Please collect payment before marking as next.`,
                                                        confirmButtonText: "OK",
                                                        confirmButtonColor: "#fd7e14",
                                                      })
                                                    }
                                                  />
                                                );
                                              }
                                              
                                              return actionLoading.markingNext === getLoadingId(patient) ? (
                                                <span
                                                  className="spinner-border spinner-border-sm text-primary"
                                                  role="status"
                                                  aria-hidden="true"
                                                ></span>
                                              ) : (
                                                <img
                                                  src={Markasnext}
                                                  alt="Mark Next"
                                                  width="28"
                                                  height="28"
                                                  className="cursor-pointer"
                                                  title="Mark as Next"
                                                  onClick={() => handleMarkNext(patient)}
                                                  style={{
                                                    opacity:
                                                      isPaused ||
                                                        actionLoading.markingNext === getLoadingId(patient)
                                                        ? 0.5
                                                        : 1,
                                                  }}
                                                />
                                              );
                                            })()
                                          ) : (
                                            <img
                                              src={Markasnext}
                                              alt="Mark Next Disabled"
                                              width="28"
                                              height="28"
                                              className="cursor-pointer"
                                              title="Please send questionnaire link first"
                                              style={{ opacity: 0.5, cursor: "not-allowed" }}
                                              onClick={() =>
                                                Swal.fire({
                                                  icon: "info",
                                                  title: "Action Required",
                                                  html: `Please <b>click the Link icon</b> to send the questionnaire.<br/>Once done, Mark Next will be enabled.`,
                                                  confirmButtonText: "OK",
                                                })
                                              }
                                            />
                                          )}
                                        </div>
                                      </div>

                                      <p
                                        className="mb-1 small"
                                        style={{
                                          color: "#6c757d",
                                          fontSize: "14px",
                                          fontWeight: 500
                                        }}
                                      >
                                        {[
                                          patient.marital_status,
                                          patient.diseases == "" || patient.diseases == null ? patient.opd_diseases : patient.diseases,
                                          patient.mode && patient.mode.trim() !== "" ? patient.mode : "Offline",
                                          patient.timeSlot,
                                          patient.doctor && `Dr ${patient.doctor}`
                                        ].filter(Boolean).join(" | ")}
                                      </p>

                                      <p
                                        className="mb-1 small"
                                        style={{
                                          color: "#6c757d",
                                          fontSize: "14px",
                                          fontWeight: 500
                                        }}
                                      >
                                        {patient.whatsapp_contact_no && (
                                          <> {patient.whatsapp_contact_no}</>
                                        )}
                                        {patient.whatsapp_contact_no && patient.location && " | "}
                                        {patient.location && (
                                          <> {patient.location}</>
                                        )}
                                      </p>

                                      <div
                                        className="d-flex flex-wrap align-items-center gap-2"
                                        style={{ rowGap: "6px" }}
                                      >
                                        {patient.showCollectButton && (
                                          <img
                                            src={collectpayment}
                                            alt="Collect Payment"
                                            width={32}
                                            height={32}
                                            className="cursor-pointer"
                                            title="Collect Payment"
                                            onClick={() => handleCollectPayment(patient)}
                                            style={{
                                              padding: "4px",
                                              objectFit: "contain",
                                            }}
                                          />
                                        )}

                                        {/* Remove/Cancel icon in Patient Queue - FIXED with permission check */}
                                        {!canPerformActions(patient) ? (
                                          <span
                                            className="d-inline-flex align-items-center justify-content-center"
                                            style={{ width: "32px", height: "32px", opacity: 0.5, cursor: "not-allowed" }}
                                            
                                            onClick={showScanPatientAlert}
                                          >
                                            <img
                                              src={cancel}
                                              alt="Cancel Disabled"
                                              style={{
                                                width: "28px",
                                                height: "28px",
                                                filter: "grayscale(100%)",
                                              }}
                                            />
                                          </span>
                                        ) : actionLoading.removing &&
                                          (actionLoading.removing === getLoadingId(patient)) ? (
                                          <span
                                            className="spinner-border spinner-border-sm text-danger"
                                            role="status"
                                            aria-hidden="true"
                                          ></span>
                                        ) : (
                                          <img
                                            src={cancel}
                                            alt="Cancel Appointment"
                                            width={32}
                                            height={32}
                                            className="cursor-pointer"
                                            title="Cancel Appointment"
                                            onClick={() => handleRemovePatient(patient)}
                                            style={{ padding: "4px", objectFit: "contain" }}
                                          />
                                        )}

                                        {/* Emergency icon in Patient Queue - FIXED with permission check */}
                                        {!canPerformActions(patient) ? (
                                          <span
                                            className="d-inline-flex align-items-center justify-content-center"
                                            style={{ width: "28px", height: "28px", opacity: 0.5, cursor: "not-allowed" }}
                                          
                                            onClick={showScanPatientAlert}
                                          >
                                            <img
                                              src={emergencyIcon}
                                              alt="Emergency Disabled"
                                              style={{
                                                width: "24px",
                                                height: "24px",
                                                filter: "grayscale(100%)",
                                              }}
                                            />
                                          </span>
                                        ) : actionLoading.emergencyMarking &&
                                          (actionLoading.emergencyMarking === getLoadingId(patient)) ? (
                                          <span
                                            className="spinner-border spinner-border-sm text-danger"
                                            role="status"
                                            aria-hidden="true"
                                          ></span>
                                        ) : (
                                          <img
                                            src={emergencyIcon}
                                            alt="Emergency"
                                            width="28"
                                            height="28"
                                            className="cursor-pointer"
                                            title={isEmergencyPatient(patient) ? "Emergency Set" : "Mark as Emergency"}
                                            style={{
                                              opacity:
                                                (actionLoading.emergencyMarking &&
                                                  (actionLoading.emergencyMarking === getLoadingId(patient)))
                                                  ? 0.5
                                                  : 1,
                                            }}
                                            onClick={() => handleEmergency(patient)}
                                          />
                                        )}

                                        {isLastPatientInQueue(patient) && (
                                          <button
                                            className="btn btn-sm btn-success"
                                            onClick={() => handleMarkComplete(patient)}
                                            title="Mark as Complete"
                                            disabled={actionLoading.completing === getLoadingId(patient)}
                                          >
                                            {actionLoading.completing === getLoadingId(patient) ? (
                                              <>
                                                <span className="spinner-border spinner-border-sm me-1"></span>
                                                Completing...
                                              </>
                                            ) : (
                                              <i className="fas fa-check-double me-1"></i>
                                            )}
                                          </button>
                                        )}

                                        {patient.showReminder && (
                                          actionLoading.sendingReminder === patient.id ? (
                                            <span className="spinner-border spinner-border-sm text-primary" role="status" aria-hidden="true"></span>
                                          ) : (
                                            <img
                                              src={remainder}
                                              alt="Send Reminder"
                                              width={32}
                                              height={32}
                                              className="cursor-pointer"
                                              title="Send Reminder"
                                              onClick={() => handleSendReminder(patient.id)}
                                              style={{
                                                padding: "4px",
                                                objectFit: "contain",
                                              }}
                                            />
                                          )
                                        )}

                                        {patient.showReceiptIcon && (
                                          <div className="d-flex align-items-center">
                                            {actionLoading.downloading === patient.payment_id ? (
                                              <div
                                                className="spinner-border text-primary"
                                                role="status"
                                                style={{ width: "24px", height: "24px" }}
                                              >
                                                <span className="visually-hidden">Loading...</span>
                                              </div>
                                            ) : (
                                              <img
                                                src={pdfIcon || "/placeholder.svg"}
                                                alt="Download PDF"
                                                width={28}
                                                height={28}
                                                style={{ cursor: "pointer" }}
                                                title="Download Receipt"
                                                onClick={() =>
                                                  handleDownloadReceipt(
                                                    patient.receipt_download_link,
                                                    patient.payment_id
                                                  )
                                                }
                                              />
                                            )}
                                          </div>
                                        )}

                                        {/* Reschedule Icon */}
                                        <img
                                          src={Reshedule || "/placeholder.svg"}
                                          alt="Reschedule"
                                          width={28}
                                          height={28}
                                          style={{ cursor: "pointer" }}
                                          title="Reschedule Appointment"
                                          onClick={() => handleReschedule(patient)}
                                        />
{(
  patient?.queueDetails?.questionnaire_filled === "No" ||
  patient?.partnerDetails?.questionnaire_filled === "No"
) && (
  <div
    className="position-relative"
    style={{ display: "inline-block" }}
  >

    {/* Share Icon */}
  {/* Share Icon */}

<div
  className="ms-sm-1"

  style={{
    width: "24px",
    height: "24px",

    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    cursor:
      sendingLinkPatientId ===
      patient?.patient_id
        ? "not-allowed"
        : "pointer",
  }}

  onClick={(e) => {

    e.stopPropagation();

    // Prevent duplicate clicks
    if (
      sendingLinkPatientId ===
      patient?.patient_id
    ) {
      return;
    }

    // Only patient pending
    if (

      patient?.queueDetails
        ?.questionnaire_filled ===
        "No" &&

      patient?.partnerDetails
        ?.questionnaire_filled !==
        "No"

    ) {

      handleSendLink(
        patient?.patient_id
      );

      return;

    }

    // Partner also pending
    setOpenShareMenuId(
      openShareMenuId ===
        patient.patient_id
          ? null
          : patient.patient_id
    );

  }}
>

{sendingLinkPatientId ===
patient?.patient_id ? (

  <div
    className="spinner-border spinner-border-sm text-primary"
    role="status"
    style={{
      width: "18px",
      height: "18px",
      borderWidth: "2px",
    }}
  >
    <span className="visually-hidden">
      Loading...
    </span>
  </div>
) : (
  <img
    src={
      Sharelink ||
      "/placeholder.svg"
    }
    alt="Share Link"
    title="Send Form Link"
    style={{
      width: "24px",
      height: "24px",
    }}
  />

)}

</div>

    {/* Dropdown Menu */}
    {openShareMenuId === patient.patient_id &&

patient?.partnerDetails
  ?.questionnaire_filled ===
  "No" &&

patient?.partnerDetails
  ?.patient_id && (

  <div
    style={{
      position: "absolute",
      top: "0",
      right: "35px",
      background: "#fff",
      border:
        "1px solid #dee2e6",
      borderRadius: "8px",
      boxShadow:
        "0 4px 12px rgba(0,0,0,0.15)",
      minWidth: "220px",
      zIndex: 9999,
      overflow: "hidden",
    }}
  >

    {/* Partner Form Link */}

    <div
   
   onClick={() => {

    if (
      sendingLinkPatientId?.toString() ===
      patient?.partnerDetails
        ?.patient_id?.toString()
    ) {
      return;
    }
  
    handleSendPartnerFormLink(
      patient
    );
  
  }}
      style={{
        padding: "10px 14px",

        cursor:
          sendingLinkPatientId ===
          patient?.partnerDetails
            ?.patient_id
            ? "not-allowed"
            : "pointer",

        fontSize: "14px",

        background: "#fff",

        opacity:
          sendingLinkPatientId ===
          patient?.partnerDetails
            ?.patient_id
            ? 0.6
            : 1,

        display: "flex",

        alignItems: "center",

        gap: "8px",
      }}

      onMouseEnter={(e) =>
        sendingLinkPatientId !==
          patient?.partnerDetails
            ?.patient_id &&
        (e.currentTarget.style.background =
          "#f8f9fa")
      }

      onMouseLeave={(e) =>
        (e.currentTarget.style.background =
          "#fff")
      }
    >

{sendingLinkPatientId?.toString() ===
patient?.partnerDetails
  ?.patient_id?.toString() ? (

  <>
    <div
      className="spinner-border spinner-border-sm text-primary"
      role="status"
      style={{
        width: "16px",
        height: "16px",
        borderWidth: "2px",
      }}
    >
      <span className="visually-hidden">
        Loading...
      </span>
    </div>

    Sending...
  </>

) : (

  <>
    <img
      src={Sharelink}
      alt="Send"
      width="16"
      height="16"
    />

    Send Partner Form Link
  </>

)}

    </div>

  </div>

)}
  </div>
)}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <Modal show={showVitalsModal} onHide={handleVitalsClose} size="lg" centered>
                  <Modal.Header closeButton>
                    <Modal.Title>Patient Vitals</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <div className="card shadow-none">
                      <div className="card-body">
                        <h5 className="font-weight-bold mb-4 ">Blood Pressure</h5>
                        <form onSubmit={handleOnSubmit}>
                          <div className="row">
                            <div className="col-md-6 mb-3">
                              <label htmlFor="systolicBP" className="form-label">
                                Systolic BP (mmHg)
                              </label>
                              <input
                                type="number"
                                className="form-control"
                                placeholder="Enter Systolic BP (mmHg) here.."
                                id="systolicBP"
                                name="systolicBP"
                                value={vitalsPatient?.systolicBP || ""}
                                onChange={handleVitalsChange}
                              />
                            </div>
                            <div className="col-md-6 mb-3">
                              <label htmlFor="diastolicBP" className="form-label">
                                Diastolic BP (mmHg)
                              </label>
                              <input
                                type="number"
                                className="form-control"
                                placeholder="Enter Diastolic BP (mmHg) here.."
                                id="diastolicBP"
                                name="diastolicBP"
                                value={vitalsPatient?.diastolicBP || ""}
                                onChange={handleVitalsChange}
                              />
                            </div>
                            <div className="col-12 mb-3">
                              <label className="form-label">Height</label>
                              <div className="d-flex align-items-center gap-2 flex-wrap">
                                <input
                                  type="number"
                                  className="form-control"
                                  placeholder="Feet"
                                  min="0"
                                  value={vitalsPatient?.heightFeet || ""}
                                  onChange={handleHeightFeetChange}
                                  style={{ width: "100px" }}
                                />
                                <span>ft</span>

                                <input
                                  type="number"
                                  className="form-control"
                                  placeholder="Inches"
                                  min="0"
                                  max="11"
                                  value={vitalsPatient?.heightInches || ""}
                                  onChange={handleHeightInchesChange}
                                  style={{ width: "100px" }}
                                />
                                <span>in</span>

                                <input
                                  type="number"
                                  className="form-control"
                                  placeholder="Centimeters"
                                  value={vitalsPatient?.height || ""}
                                  onChange={handleHeightCmChange}
                                  style={{ width: "140px" }}
                                />
                                <span>cm</span>
                              </div>
                            </div>

                            <div className="col-md-6 mb-3">
                              <label htmlFor="weight" className="form-label">
                                Weight (kg)
                              </label>
                              <input
                                type="number"
                                className="form-control"
                                placeholder="Enter Weight (kg) here.."
                                id="weight"
                                value={vitalsPatient?.weight || ""}
                                onChange={handleWeightChange}
                              />
                            </div>

                            <div className="col-md-6 mb-3">
                              <label htmlFor="bmi" className="form-label">
                                BMI
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="bmi"
                                value={vitalsPatient?.bmi || ""}
                                readOnly
                              />
                            </div>

                            <div className="col-12 mb-3">
                              <label htmlFor="reports" className="form-label">
                                Reports Upload<small className="text-muted">(Only JPG or PNG allowed)</small>
                              </label>

                              <div className="d-flex align-items-center w-100 gap-2">
                                <input
                                  type="file"
                                  id="reports"
                                  accept="image/jpeg, image/png"
                                  capture="environment"
                                  onChange={handleFileChange}
                                  style={{ display: "none" }}
                                />

                                <div className="d-flex gap-2">
                                  <label
                                    htmlFor="reports"
                                    className="btn btn-outline-primary mb-0 d-flex align-items-center"
                                    style={{
                                      height: "38px",
                                      padding: "0 15px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    Choose Photo
                                  </label>

                                  <button
                                    type="button"
                                    className="btn btn-outline-info mb-0 d-flex align-items-center"
                                    style={{
                                      height: "38px",
                                      padding: "0 15px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      whiteSpace: "nowrap",
                                    }}
                                    onClick={() => {
                                      localStorage.setItem("photoSource", "vitals");
                                      openCameraTab();
                                    }}
                                  >
                                    Take Photo
                                  </button>
                                </div>

                                <div className="position-relative w-100">
                                  <input
                                    type="text"
                                    className="form-control"
                                    readOnly
                                    style={{ height: "38px" }}
                                    value={vitalsPatient?.uploadedFileName || ""}
                                    placeholder="No file chosen"
                                  />

                                  {vitalsPatient?.uploadedFileName && (
                                    <span
                                      style={{
                                        position: "absolute",
                                        right: "10px",
                                        top: "50%",
                                        transform: "translateY(-50%)",
                                        cursor: "pointer",
                                        fontWeight: "bold",
                                        fontSize: "18px",
                                        lineHeight: 1,
                                        color: "#dc3545",
                                      }}
                                      title="Clear"
                                      onClick={() => {
                                        setVitalsPatient((prev) => ({
                                          ...prev,
                                          uploadedFile: null,
                                          uploadedFileName: null,
                                        }));
                                        setUploadedFiles([]);
                                        const fileInput = document.getElementById("reports");
                                        if (fileInput) fileInput.value = "";
                                      }}
                                    >
                                      ×
                                    </span>
                                  )}
                                </div>
                              </div>
                            </div>

                            {uploadedFiles.length > 0 && (
                              <div className="col-12 mt-3">
                                <div className="table-responsive">
                                  <table className="table table-bordered">
                                    <thead>
                                      <tr>
                                        <th>File Name</th>
                                        <th>Actions</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {uploadedFiles.map((file, index) => (
                                        <tr key={index}>
                                          <td>{file.name}</td>
                                          <td>
                                            <button
                                              type="button"
                                              className="btn btn-link"
                                              title="View"
                                              onClick={() => handleView(file)}
                                            >
                                              <i className="fa fa-eye fs-18" />
                                            </button>
                                            <button
                                              className="btn btn-link text-danger"
                                              title="Delete"
                                              onClick={() => handleDelete(index)}
                                            >
                                              <i className="fa fa-trash fs-18" />
                                            </button>
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            )}
                          </div>
                          <button type="submit" className="btn btn-primary" disabled={submittingVitals}>
                            {submittingVitals ? (
                              <>
                                <span className="spinner-border spinner-border-sm me-2"></span>
                                Saving...
                              </>
                            ) : (
                              "Save"
                            )}
                          </button>
                        </form>
                      </div>
                    </div>
                  </Modal.Body>
                </Modal>

                <CommonPaymentModal
                  show={showModal}
                  onHide={() => setShowModal(false)}
                  title="Collect Payment"
                  patientName={selectedPatient?.name}
                  initialAmount=""
                  onSubmit={handlePaymentSubmit}
                  loading={actionLoading.collectingPayment}
                  paymentType="appointment"
                  paymentData={{
                    queue_id: selectedPatient?.queue_id,
                    patient_id: selectedPatient?.patient_id,
                    doctor_id: selectedPatient?.doctor_id || selectedDoctorId || 0,
                    date: selectedPatient?.date,                    // ✅ appointment date (YYYY-MM-DD)
                    appointment_camp_reg: selectedPatient?.appointment_camp_reg,
                  }}
                  paymentFor="APPOINTMENT"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-4">
        <Appointmentlist />
      </div>

      {/* 📸 Photo Upload Modal */}
      <Modal
        show={!!photoModalPatient}
        onHide={() => setPhotoModalPatient(null)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Upload Patient Photo</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <Button
            variant="primary"
            className="w-100 mb-3"
            onClick={() => {
              document.getElementById(`choose-photo-${photoModalPatient?.patient_id}`).click();
              setPhotoModalPatient(null);
            }}
          >
            <i className="fas fa-image me-2"></i> Choose Photo
          </Button>

          <Button
            variant="success"
            className="w-100"
            onClick={() => {
              localStorage.setItem("photoSource", "queue");
              localStorage.setItem("photoPatientId", photoModalPatient?.patient_id);
              setPhotoModalPatient(null);
              openCameraTab();
            }}
          >
            <i className="fas fa-camera me-2"></i> Take Photo
          </Button>
        </Modal.Body>
      </Modal>

   

<Modal show={showSlotModal} onHide={() => {
  setShowSlotModal(false);
  resetSlotModalStates();
}} centered size="lg">
  <Modal.Header closeButton>
    <Modal.Title>
      {(() => {
        const appointmentState = getAppointmentState(appointmentDetails);
        return `${appointmentState.modalTitle} for ${selectedPatient?.patient_name || appointmentDetails?.patient_name || "Patient"}`;
      })()}
    </Modal.Title>
  </Modal.Header>

  <Modal.Body>
    {selectedPatient && (
      <div className="alert alert-info mb-4">
        <div className="d-flex align-items-center">
          <div className="me-3">
            <i className="fas fa-user-circle fa-2x"></i>
          </div>
          <div>
  <h6 className="mb-1">
    {selectedPatient?.patient_name ||
      `${appointmentDetails?.first_name || ""} ${
        appointmentDetails?.last_name || ""
      }`.trim() ||
      "Patient"}
  </h6>

  <small className="text-muted">
    {(selectedPatient?.patient_phone ||
      appointmentDetails?.whatsapp_contact_no ||
      "No contact")}

    {" | "}

    {(selectedPatient?.patient_email ||
      appointmentDetails?.patient_email) &&
    (selectedPatient?.patient_email ||
      appointmentDetails?.patient_email) !== ""
      ? (selectedPatient?.patient_email ||
          appointmentDetails?.patient_email)
      : "Email not provided"}
  </small>
</div>
        </div>
      </div>
    )}

    {/* Display existing appointment details if available */}
    {appointmentDetails &&(
      <div className="alert alert-warning mb-4">
        <h6 className="mb-12">
          <i className="fas fa-calendar-check me-2"></i>
          Existing Appointment Details <small className="text-muted"><i>
          (You can modify the details below if needed)</i>
        </small>
        </h6>
        <div className="row mt-4">
          <div className="col-md-4 mb-2">
            <small className="text-muted d-block">Doctor</small>
            <strong>
  {appointmentDetails?.doctor_id === 0 ||
   appointmentDetails?.doctor_id === "0"
    ? "-"
    : doctors.find(
        (doc) => doc.doctor_id === appointmentDetails?.doctor_id
      )?.doctor_name || "Not assigned"}
</strong>
          </div>
          <div className="col-md-8 mb-2">
            <small className="text-muted d-block">Date</small>
            <label><strong>{formatDate(appointmentDetails?.date) || "NA"}</strong> {appointmentDetails?.time_slot || "" }{" "}
<span
  className={`badge ${
    appointmentDetails?.is_confirmed === "Yes"
      ? "bg-success"
      : "bg-warning"
  }`}
>
  {appointmentDetails?.is_confirmed === "Yes"
    ? "Confirmed"
    : "Not Confirmed"}
</span>
</label>
          </div>
          {/* <div className="col-md-6 mb-2">
            <small className="text-muted d-block">Time Slot</small>
            <strong>{appointmentDetails?.time_slot || "Not set"}</strong>
          </div> */}
          {/* <div className="col-md-6 mb-2">
            <small className="text-muted d-block">Status</small>
            <strong>
              <span className={`badge ${appointmentDetails?.is_confirmed === "Yes" ? "bg-success" : "bg-warning"}`}>
                {appointmentDetails?.is_confirmed === "Yes" ? "Confirmed" : "Not Confirmed"}
              </span>
            </strong>
          </div> */}
        </div>
        
      </div>
    )}

    {/* Loading state for appointment details */}
    {fetchingAppointmentDetails && (
      <div className="alert alert-info mb-4">
        <i className="fas fa-spinner fa-spin me-2"></i>
        Fetching appointment details...
      </div>
    )}
  {/* ✅ DATE PICKER - NEW */}
    {(() => {
      // ✅ READONLY MODE: Disable when is_confirmed === "Yes" (CASE 2 and CASE 3)
      const isReadOnly = appointmentDetails?.is_confirmed === "Yes";
      
      return (
        <div className="row">
          <div className="col-md-6 mb-3">
            <label className="form-label fw-bold">
              Select Date <span className="text-danger">*</span>
            
            </label>
            <input
              type="date"
              className="form-control"
              value={modalDate}
              min={new Date().toISOString().split("T")[0]}
              disabled={isReadOnly}
              style={{
                backgroundColor: isReadOnly ? "#f5f5f5" : "white",
                cursor: isReadOnly ? "not-allowed" : "pointer"
              }}
              onChange={(e) => {
                if (!isReadOnly) {
                  setModalDate(e.target.value);
                  setModalTimeSlot(null); // Reset time slot when date changes in new appointment
                }
              }}
            />
          </div>
          {/* Doctor selection */}
          <div className="col-md-6 mb-4">
            <label className="form-label fw-bold">
              Select Doctor <span className="text-danger">*</span>
              
            </label>
            <Select
              options={modalDoctorOptions}
              value={modalDoctorOptions.find((opt) => opt.value === modalDoctorId)}
              onChange={handleModalDoctorChange}
              isDisabled={isReadOnly}
              placeholder="Search and select doctor..."
              formatOptionLabel={({ label, specialization }) => (
                <div>
                  <div style={{ fontWeight: "bold" }}>{label}</div>
                  <div style={{ fontSize: "0.8em", color: "#666" }}>{specialization}</div>
                </div>
              )}
              isClearable={!isReadOnly}
              styles={{
                control: (base) => ({
                  ...base,
                  minHeight: "55px",
                  backgroundColor: isReadOnly ? "#f5f5f5" : "white",
                  borderColor: !modalDoctorId && !isReadOnly ? "#ffc107" : base.borderColor,
                  boxShadow: !modalDoctorId && !isReadOnly ? "0 0 0 0.2rem rgba(255,193,7,.25)" : base.boxShadow,
                  cursor: isReadOnly ? "not-allowed" : "pointer"
                }),
              }}
            />
            {!modalDoctorId && !isReadOnly && (
              <small className="text-warning mt-1 d-block">
                <i className="fas fa-exclamation-triangle me-1"></i>
                Please select a doctor to continue
              </small>
            )}
          </div>
        </div>
      );
    })()}

  

    {/* Time slot selection */}
    {(() => {
      // ✅ READONLY MODE: Disable when is_confirmed === "Yes" (CASE 2 and CASE 3)
      const isReadOnly = appointmentDetails?.is_confirmed === "Yes";
      
      return (
        <div className="mb-3">
          <label className="form-label fw-bold">
            Select Time Slot <span className="text-danger">*</span>
           
          </label>

          {!modalDoctorId || modalDoctorId === "0" ? (
            <small className="text-muted">Please select doctor first</small>
          ) : (
            <div className="row">
              {slotsData.map((slot, index) => (
                <div className="col-md-6 mb-2" key={index}>
                  <div
                    className={`border rounded p-2 d-flex justify-content-between align-items-center ${
                      modalTimeSlot?.value === slot.value ? "border-primary bg-light" : ""
                    } ${isReadOnly ? "opacity-75" : ""}`}
                    style={{ 
                      cursor: isReadOnly ? "not-allowed" : "pointer",
                      pointerEvents: isReadOnly ? "none" : "auto"
                    }}
                  >
                    <div className="form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="timeslot"
                        disabled={slot.is_full || isReadOnly}
                        checked={modalTimeSlot?.value === slot.value}
                        onChange={() => {
                          if (!isReadOnly) {
                            setModalTimeSlot(slot);
                          }
                        }}
                      />
                      <label className="form-check-label fw-bold">{slot.label}</label>
                    </div>
                    <span className="badge bg-info">
                      {slot.confirmed}/{slot.max}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      );
    })()}

    {/* Booking summary */}
    {modalDoctorId && modalDate && modalTimeSlot && (
      <div className="alert alert-success mt-4">
        <h6 className="alert-heading fw-bold">Appointment Summary</h6>
        <hr className="my-2" />
        <p className="mb-1">
          <strong>Doctor:</strong>{" "}
          {modalDoctorOptions.find((d) => d.value === modalDoctorId)?.label}
        </p>
        <p className="mb-1">
          <strong>Date:</strong>{" "}
          <strong>{formatDate(modalDate)}</strong> {modalTimeSlot.label} {(
  appointmentDetails?.branch_name?.trim() ||
  modalTimeSlot?.branch_name?.trim()
) && (
  <>
    {" "}at{" "}
    {appointmentDetails?.branch_name?.trim()
      ? appointmentDetails.branch_name
      : modalTimeSlot?.branch_name}
  </>
)}
        </p>
        {/* <p className="mb-0">
          <strong>Time:</strong> {modalTimeSlot.label}
        </p> */}
        {/* <div style={{ fontSize: "14px", marginTop: "8px" }}>
  <strong>Branch:</strong>{" "}
  {appointmentDetails?.branch_name ||
    modalTimeSlot?.branch_name ||
    "-"}
</div> */}
      </div>
    )}
  </Modal.Body>

  <Modal.Footer>
     {/* Case 3: Hide Both Buttons when BOTH is_confirmed === "Yes" AND is_presented === "Yes" */}
          {(appointmentDetails?.is_confirmed === "Yes" && appointmentDetails?.is_presented === "Yes") && (
            <small className="text-info ms-2">
              <i className="fas fa-check-circle me-1"></i>
              Patient already added to queue
            </small>
          )}
    <button className="btn btn-danger" onClick={() => {
      setShowSlotModal(false);
      resetSlotModalStates();
    }}>
      Cancel
    </button>
    
    {/* ✅ USE CENTRALIZED APPOINTMENT STATE FOR BUTTON RENDERING */}
    {(() => {
      const appointmentState = getAppointmentState(appointmentDetails);
      
      return (
        <>
          {/* Show Confirm Button: CASE 1 (is_confirmed === "No") or CASE 4 (appointmentDetails === null) */}
          {(appointmentDetails == null || appointmentDetails?.is_confirmed == "No") && (
            <button
              className="btn btn-primary"
              onClick={handleConfirmSlot}
              disabled={!modalDoctorId || !modalDate || !modalTimeSlot || actionLoading.confirmingSlot}
              title="Confirm appointment"
            >
              {actionLoading.confirmingSlot ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Booking...
                </>
              ) : (
                <>
                  <i className="fas fa-check me-2"></i>
                  Confirm Appointment
                </>
              )}
            </button>
          )}
          
          {/* Show Add to Queue Button ONLY when: is_confirmed === "Yes" AND is_presented !== "Yes" (CASE 2) */}
          {(appointmentDetails?.is_confirmed === "Yes" && appointmentDetails?.is_presented !== "Yes") && (
            <button
              className="btn btn-success"
              onClick={handleConfirmSlot}
              disabled={!modalDoctorId || !modalDate || !modalTimeSlot || actionLoading.confirmingSlot}
              title="Add confirmed appointment to queue"
            >
              {actionLoading.confirmingSlot ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Adding to Queue...
                </>
              ) : (
                <>
                  <i className="fas fa-plus me-2"></i>
                  Add to Queue
                </>
              )}
            </button>
          )}
          
          {/* Case 3: Hide Both Buttons when BOTH is_confirmed === "Yes" AND is_presented === "Yes" */}
          {/* {(appointmentDetails?.is_confirmed === "Yes" && appointmentDetails?.is_presented === "Yes") && (
            <small className="text-info ms-2">
              <i className="fas fa-check-circle me-1"></i>
              Patient already added to queue
            </small>
          )} */}
        </>
      );
    })()}
  </Modal.Footer>
</Modal>

{/* RESCHEDULE APPOINTMENT MODAL */}
<Modal show={showRescheduleModal} onHide={() => {
  setShowRescheduleModal(false);
  resetRescheduleModalStates();
}} centered size="lg">
  <Modal.Header closeButton>
    <Modal.Title>
      Reschedule Appointment for {selectedAppointmentForReschedule?.patient_name || appointmentDetails?.patient_name || "Patient"}
    </Modal.Title>
  </Modal.Header>

  <Modal.Body>
  {appointmentDetails && (
  <div className="alert alert-info mb-4">
    <div className="d-flex align-items-center justify-content-between">

      {/* Left Side */}
      <div className="d-flex align-items-center">
        <div className="me-3">
          <i
            className="fas fa-user-circle text-primary"
            style={{ fontSize: "40px" }}
          ></i>
        </div>

        <div>
          <h6 className="mb-1 fw-bold">
            {`${appointmentDetails.first_name || ""} ${
              appointmentDetails.last_name || ""
            }`.trim()}
          </h6>

          <small className="text-muted">
            <i className="fas fa-phone-alt me-1"></i>
            {appointmentDetails.whatsapp_contact_no || "No contact"}
          </small>
        </div>
      </div>

      {/* Eye Icon */}
      <Link
        to="#"
        title="Preview Patient"
        className="d-inline-flex align-items-center justify-content-center"
        style={{
          width: "35px",
          height: "35px",
          borderRadius: "50%",
          background: "#fff",
        }}
        onClick={(e) => {
          e.preventDefault();
          handlePatientClick(appointmentDetails);
        }}
      >
        <i className="fa fa-eye text-primary fs-5"></i>
      </Link>
    </div>
  </div>
)}
    {fetchingAppointmentDetails && (
      <div className="alert alert-warning mb-4">
        <i className="fas fa-spinner fa-spin me-2"></i>
        Loading appointment details...
      </div>
    )}

    {appointmentDetails && (
      <div className="alert alert-warning mb-4">
        <h6 className="mb-3">
          <i className="fas fa-calendar-check me-2"></i>
          Current Appointment Details<small className="text-muted"><i>
          (You can modify the details below if needed)</i>
        </small>
        </h6>
        <div className="row mt-4">
  <div className="col-md-4 mb-2">
    <small className="text-muted d-block">Doctor</small>

    <strong>
  {appointmentDetails?.doctor_id === 0 ||
  appointmentDetails?.doctor_id === "0"
    ? "-"
    : (
        rescheduleModalDoctorOptions.length > 0
          ? rescheduleModalDoctorOptions
          : modalDoctorOptions
      ).find(
        (d) =>
          String(d.value) ===
          String(
            appointmentDetails?.doctor_id
          )
      )?.label ||
      appointmentDetails?.doctor_name ||
      "Not assigned"}
</strong>
  </div>

  <div className="col-md-8 mb-2">
    <small className="text-muted d-block">Date</small>

    <label>
      <strong>
        {formatDate(appointmentDetails?.date) || "NA"}
      </strong>{" "}
      {appointmentDetails?.time_slot || ""}

      <span
        className={`badge ms-2 ${
          appointmentDetails?.is_confirmed === "Yes"
            ? "bg-success"
            : "bg-warning"
        }`}
      >
        {appointmentDetails?.is_confirmed === "Yes"
          ? "Confirmed"
          : "Not Confirmed"}
      </span>
    </label>
  </div>
</div>
   
      </div>
    )}

     <div className="row">
       {/* DATE PICKER */}
    <div className="col-md-6 mb-3">
      <label className="form-label fw-bold">
        Select New Date <span className="text-danger">*</span>
      </label>
      <input
        type="date"
        className="form-control"
        value={rescheduleModalDate}
        min={new Date().toISOString().split("T")[0]}
        onChange={(e) => {
          setRescheduleModalDate(e.target.value);
          setRescheduleModalTimeSlot(null); // reset selected time slot when date changes
        }}
      />
    </div>
    {/* Doctor selection */}
    <div className="col-md-6 mb-3">
      <label className="form-label fw-bold">
        Select Doctor <span className="text-danger">*</span>
      </label>
      <Select
        options={rescheduleModalDoctorOptions.length > 0 ? rescheduleModalDoctorOptions : modalDoctorOptions}
        value={(rescheduleModalDoctorOptions.length > 0 ? rescheduleModalDoctorOptions : modalDoctorOptions).find(
          (opt) => opt.value === rescheduleModalDoctorId
        )}
        onChange={handleRescheduleModalDoctorChange}
        placeholder="Search and select doctor..."
        formatOptionLabel={({ label, specialization }) => (
          <div>
            <div style={{ fontWeight: "bold" }}>{label}</div>
            <div style={{ fontSize: "0.8em", color: "#666" }}>{specialization}</div>
          </div>
        )}
        isClearable
        styles={{
          control: (base) => ({
            ...base,
            minHeight: "55px",
            borderColor: !rescheduleModalDoctorId ? "#ffc107" : base.borderColor,
            boxShadow: !rescheduleModalDoctorId ? "0 0 0 0.2rem rgba(255,193,7,.25)" : base.boxShadow,
          }),
        }}
      />
      {!rescheduleModalDoctorId && (
        <small className="text-warning mt-1 d-block">
          <i className="fas fa-exclamation-triangle me-1"></i>
          Please select a doctor to continue
        </small>
      )}
    </div>

   
   </div>
    {/* Time slot selection */}
    <div className="mb-3">
      <label className="form-label fw-bold">
        Select New Time Slot <span className="text-danger">*</span>
      </label>

      {!rescheduleModalDoctorId ? (
        <small className="text-muted">Please select doctor first</small>
      ) : (
        <div className="row">
          {rescheduleSlotsData.length > 0 ? (
            rescheduleSlotsData.map((slot, index) => (
              <div className="col-md-6 mb-2" key={index}>
                <div
                  className={`border rounded p-2 d-flex justify-content-between align-items-center ${
                    rescheduleModalTimeSlot?.value === slot.value ? "border-primary bg-light" : ""
                  }`}
                >
                  <div className="form-check">
                    <input
                      type="radio"
                      className="form-check-input"
                      name="rescheduleTimeslot"
                      disabled={slot.is_full}
                      checked={rescheduleModalTimeSlot?.value === slot.value}
                      onChange={() => setRescheduleModalTimeSlot(slot)}
                    />
                    <label className="form-check-label fw-bold">{slot.label}</label>
                  </div>
                  <span className="badge bg-info">
                    {slot.confirmed}/{slot.max}
                  </span>
                </div>
              </div>
            ))
          ) : (
            <small className="text-muted">No available slots for selected doctor and date</small>
          )}
        </div>
      )}
    </div>

    {/* Reschedule summary */}
    {rescheduleModalDoctorId && rescheduleModalDate && rescheduleModalTimeSlot && (
      <div className="alert alert-success mt-4">
        <h6 className="alert-heading fw-bold">Reschedule Summary</h6>
        <hr className="my-2" />
        <p className="mb-1">
          <strong>Doctor:</strong>{" "}
          {(rescheduleModalDoctorOptions.length > 0 ? rescheduleModalDoctorOptions : modalDoctorOptions).find(
            (d) => d.value === rescheduleModalDoctorId
          )?.label}
        </p>
        <p className="mb-1">
  <strong>New Date:</strong>{" "}
  <strong>{formatDate(rescheduleModalDate)}</strong>{" "}
  {rescheduleModalTimeSlot?.label} at{" "}
  {appointmentDetails?.branch_name ||
    rescheduleModalTimeSlot?.branch_name ||
    "-"}
</p>
       
      </div>
    )}
  </Modal.Body>

  <Modal.Footer>
    <button
      className="btn btn-danger"
      onClick={() => {
        setShowRescheduleModal(false);
        resetRescheduleModalStates();
      }}
    >
      Cancel
    </button>
    <button
      className="btn btn-primary"
      onClick={handleConfirmReschedule}
      disabled={
        !rescheduleModalDoctorId ||
        !rescheduleModalDate ||
        !rescheduleModalTimeSlot ||
        actionLoading.reschedulingSlot
      }
    >
      {actionLoading.reschedulingSlot ? (
        <>
          <span
            className="spinner-border spinner-border-sm me-2"
            role="status"
            aria-hidden="true"
          ></span>
          Rescheduling...
        </>
      ) : (
        <>
          <i className="fas fa-calendar-check me-2"></i>
          Confirm Reschedule
        </>
      )}
    </button>
  </Modal.Footer>
</Modal>

    </div>
  )
}
export default Receptionist